var _templateObject, _templateObject2;
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/*
Turbo 7.3.0
Copyright © 2023 37signals LLC
 */
(function () {
  if (window.Reflect === undefined || window.customElements === undefined || window.customElements.polyfillWrapFlushCallback) {
    return;
  }
  var BuiltInHTMLElement = HTMLElement;
  var wrapperForTheName = {
    HTMLElement: function HTMLElement() {
      return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
    }
  };
  window.HTMLElement = wrapperForTheName["HTMLElement"];
  HTMLElement.prototype = BuiltInHTMLElement.prototype;
  HTMLElement.prototype.constructor = HTMLElement;
  Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();

/**
 * The MIT License (MIT)
 * 
 * Copyright (c) 2019 Javan Makhmali
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

(function (prototype) {
  if (typeof prototype.requestSubmit == "function") return;
  prototype.requestSubmit = function (submitter) {
    if (submitter) {
      validateSubmitter(submitter, this);
      submitter.click();
    } else {
      submitter = document.createElement("input");
      submitter.type = "submit";
      submitter.hidden = true;
      this.appendChild(submitter);
      submitter.click();
      this.removeChild(submitter);
    }
  };
  function validateSubmitter(submitter, form) {
    submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'");
    submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button");
    submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError");
  }
  function raise(errorConstructor, message, name) {
    throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name);
  }
})(HTMLFormElement.prototype);
var submittersByForm = new WeakMap();
function findSubmitterFromClickTarget(target) {
  var element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
  var candidate = element ? element.closest("input, button") : null;
  return (candidate === null || candidate === void 0 ? void 0 : candidate.type) == "submit" ? candidate : null;
}
function clickCaptured(event) {
  var submitter = findSubmitterFromClickTarget(event.target);
  if (submitter && submitter.form) {
    submittersByForm.set(submitter.form, submitter);
  }
}
(function () {
  if ("submitter" in Event.prototype) return;
  var prototype = window.Event.prototype;
  if ("SubmitEvent" in window && /Apple Computer/.test(navigator.vendor)) {
    prototype = window.SubmitEvent.prototype;
  } else if ("SubmitEvent" in window) {
    return;
  }
  addEventListener("click", clickCaptured, true);
  Object.defineProperty(prototype, "submitter", {
    get: function get() {
      if (this.type == "submit" && this.target instanceof HTMLFormElement) {
        return submittersByForm.get(this.target);
      }
    }
  });
})();
var FrameLoadingStyle;
(function (FrameLoadingStyle) {
  FrameLoadingStyle["eager"] = "eager";
  FrameLoadingStyle["lazy"] = "lazy";
})(FrameLoadingStyle || (FrameLoadingStyle = {}));
var FrameElement = /*#__PURE__*/function (_HTMLElement) {
  function FrameElement() {
    var _this;
    _classCallCheck(this, FrameElement);
    _this = _callSuper(this, FrameElement);
    _this.loaded = Promise.resolve();
    _this.delegate = new FrameElement.delegateConstructor(_this);
    return _this;
  }
  _inherits(FrameElement, _HTMLElement);
  return _createClass(FrameElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.delegate.connect();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.delegate.disconnect();
    }
  }, {
    key: "reload",
    value: function reload() {
      return this.delegate.sourceURLReloaded();
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name) {
      if (name == "loading") {
        this.delegate.loadingStyleChanged();
      } else if (name == "complete") {
        this.delegate.completeChanged();
      } else if (name == "src") {
        this.delegate.sourceURLChanged();
      } else {
        this.delegate.disabledChanged();
      }
    }
  }, {
    key: "src",
    get: function get() {
      return this.getAttribute("src");
    },
    set: function set(value) {
      if (value) {
        this.setAttribute("src", value);
      } else {
        this.removeAttribute("src");
      }
    }
  }, {
    key: "loading",
    get: function get() {
      return frameLoadingStyleFromString(this.getAttribute("loading") || "");
    },
    set: function set(value) {
      if (value) {
        this.setAttribute("loading", value);
      } else {
        this.removeAttribute("loading");
      }
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.hasAttribute("disabled");
    },
    set: function set(value) {
      if (value) {
        this.setAttribute("disabled", "");
      } else {
        this.removeAttribute("disabled");
      }
    }
  }, {
    key: "autoscroll",
    get: function get() {
      return this.hasAttribute("autoscroll");
    },
    set: function set(value) {
      if (value) {
        this.setAttribute("autoscroll", "");
      } else {
        this.removeAttribute("autoscroll");
      }
    }
  }, {
    key: "complete",
    get: function get() {
      return !this.delegate.isLoading;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this.ownerDocument === document && !this.isPreview;
    }
  }, {
    key: "isPreview",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.documentElement) === null || _b === void 0 ? void 0 : _b.hasAttribute("data-turbo-preview");
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["disabled", "complete", "loading", "src"];
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
function frameLoadingStyleFromString(style) {
  switch (style.toLowerCase()) {
    case "lazy":
      return FrameLoadingStyle.lazy;
    default:
      return FrameLoadingStyle.eager;
  }
}
function expandURL(locatable) {
  return new URL(locatable.toString(), document.baseURI);
}
function getAnchor(url) {
  var anchorMatch;
  if (url.hash) {
    return url.hash.slice(1);
  } else if (anchorMatch = url.href.match(/#(.*)$/)) {
    return anchorMatch[1];
  }
}
function getAction(form, submitter) {
  var action = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formaction")) || form.getAttribute("action") || form.action;
  return expandURL(action);
}
function getExtension(url) {
  return (getLastPathComponent(url).match(/\.[^.]*$/) || [])[0] || "";
}
function isHTML(url) {
  return !!getExtension(url).match(/^(?:|\.(?:htm|html|xhtml|php))$/);
}
function isPrefixedBy(baseURL, url) {
  var prefix = getPrefix(url);
  return baseURL.href === expandURL(prefix).href || baseURL.href.startsWith(prefix);
}
function locationIsVisitable(location, rootLocation) {
  return isPrefixedBy(location, rootLocation) && isHTML(location);
}
function getRequestURL(url) {
  var anchor = getAnchor(url);
  return anchor != null ? url.href.slice(0, -(anchor.length + 1)) : url.href;
}
function toCacheKey(url) {
  return getRequestURL(url);
}
function urlsAreEqual(left, right) {
  return expandURL(left).href == expandURL(right).href;
}
function getPathComponents(url) {
  return url.pathname.split("/").slice(1);
}
function getLastPathComponent(url) {
  return getPathComponents(url).slice(-1)[0];
}
function getPrefix(url) {
  return addTrailingSlash(url.origin + url.pathname);
}
function addTrailingSlash(value) {
  return value.endsWith("/") ? value : value + "/";
}
var FetchResponse = /*#__PURE__*/function () {
  function FetchResponse(response) {
    _classCallCheck(this, FetchResponse);
    this.response = response;
  }
  return _createClass(FetchResponse, [{
    key: "succeeded",
    get: function get() {
      return this.response.ok;
    }
  }, {
    key: "failed",
    get: function get() {
      return !this.succeeded;
    }
  }, {
    key: "clientError",
    get: function get() {
      return this.statusCode >= 400 && this.statusCode <= 499;
    }
  }, {
    key: "serverError",
    get: function get() {
      return this.statusCode >= 500 && this.statusCode <= 599;
    }
  }, {
    key: "redirected",
    get: function get() {
      return this.response.redirected;
    }
  }, {
    key: "location",
    get: function get() {
      return expandURL(this.response.url);
    }
  }, {
    key: "isHTML",
    get: function get() {
      return this.contentType && this.contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/);
    }
  }, {
    key: "statusCode",
    get: function get() {
      return this.response.status;
    }
  }, {
    key: "contentType",
    get: function get() {
      return this.header("Content-Type");
    }
  }, {
    key: "responseText",
    get: function get() {
      return this.response.clone().text();
    }
  }, {
    key: "responseHTML",
    get: function get() {
      if (this.isHTML) {
        return this.response.clone().text();
      } else {
        return Promise.resolve(undefined);
      }
    }
  }, {
    key: "header",
    value: function header(name) {
      return this.response.headers.get(name);
    }
  }]);
}();
function activateScriptElement(element) {
  if (element.getAttribute("data-turbo-eval") == "false") {
    return element;
  } else {
    var createdScriptElement = document.createElement("script");
    var cspNonce = getMetaContent("csp-nonce");
    if (cspNonce) {
      createdScriptElement.nonce = cspNonce;
    }
    createdScriptElement.textContent = element.textContent;
    createdScriptElement.async = false;
    copyElementAttributes(createdScriptElement, element);
    return createdScriptElement;
  }
}
function copyElementAttributes(destinationElement, sourceElement) {
  var _iterator = _createForOfIteratorHelper(sourceElement.attributes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref = _step.value;
      var name = _ref.name;
      var value = _ref.value;
      destinationElement.setAttribute(name, value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function createDocumentFragment(html) {
  var template = document.createElement("template");
  template.innerHTML = html;
  return template.content;
}
function dispatch(eventName) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    target = _ref2.target,
    cancelable = _ref2.cancelable,
    detail = _ref2.detail;
  var event = new CustomEvent(eventName, {
    cancelable: cancelable,
    bubbles: true,
    composed: true,
    detail: detail
  });
  if (target && target.isConnected) {
    target.dispatchEvent(event);
  } else {
    document.documentElement.dispatchEvent(event);
  }
  return event;
}
function nextAnimationFrame() {
  return new Promise(function (resolve) {
    return requestAnimationFrame(function () {
      return resolve();
    });
  });
}
function nextEventLoopTick() {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve();
    }, 0);
  });
}
function nextMicrotask() {
  return Promise.resolve();
}
function parseHTMLDocument() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return new DOMParser().parseFromString(html, "text/html");
}
function unindent(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  var lines = interpolate(strings, values).replace(/^\n/, "").split("\n");
  var match = lines[0].match(/^\s+/);
  var indent = match ? match[0].length : 0;
  return lines.map(function (line) {
    return line.slice(indent);
  }).join("\n");
}
function interpolate(strings, values) {
  return strings.reduce(function (result, string, i) {
    var value = values[i] == undefined ? "" : values[i];
    return result + string + value;
  }, "");
}
function uuid() {
  return Array.from({
    length: 36
  }).map(function (_, i) {
    if (i == 8 || i == 13 || i == 18 || i == 23) {
      return "-";
    } else if (i == 14) {
      return "4";
    } else if (i == 19) {
      return (Math.floor(Math.random() * 4) + 8).toString(16);
    } else {
      return Math.floor(Math.random() * 15).toString(16);
    }
  }).join("");
}
function getAttribute(attributeName) {
  for (var _len2 = arguments.length, elements = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    elements[_key2 - 1] = arguments[_key2];
  }
  var _iterator2 = _createForOfIteratorHelper(elements.map(function (element) {
      return element === null || element === void 0 ? void 0 : element.getAttribute(attributeName);
    })),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var value = _step2.value;
      if (typeof value == "string") return value;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return null;
}
function hasAttribute(attributeName) {
  for (var _len3 = arguments.length, elements = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    elements[_key3 - 1] = arguments[_key3];
  }
  return elements.some(function (element) {
    return element && element.hasAttribute(attributeName);
  });
}
function markAsBusy() {
  for (var _len4 = arguments.length, elements = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    elements[_key4] = arguments[_key4];
  }
  for (var _i = 0, _elements = elements; _i < _elements.length; _i++) {
    var element = _elements[_i];
    if (element.localName == "turbo-frame") {
      element.setAttribute("busy", "");
    }
    element.setAttribute("aria-busy", "true");
  }
}
function clearBusyState() {
  for (var _len5 = arguments.length, elements = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    elements[_key5] = arguments[_key5];
  }
  for (var _i2 = 0, _elements2 = elements; _i2 < _elements2.length; _i2++) {
    var element = _elements2[_i2];
    if (element.localName == "turbo-frame") {
      element.removeAttribute("busy");
    }
    element.removeAttribute("aria-busy");
  }
}
function waitForLoad(element) {
  var timeoutInMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  return new Promise(function (resolve) {
    var _onComplete = function onComplete() {
      element.removeEventListener("error", _onComplete);
      element.removeEventListener("load", _onComplete);
      resolve();
    };
    element.addEventListener("load", _onComplete, {
      once: true
    });
    element.addEventListener("error", _onComplete, {
      once: true
    });
    setTimeout(resolve, timeoutInMilliseconds);
  });
}
function getHistoryMethodForAction(action) {
  switch (action) {
    case "replace":
      return history.replaceState;
    case "advance":
    case "restore":
      return history.pushState;
  }
}
function isAction(action) {
  return action == "advance" || action == "replace" || action == "restore";
}
function getVisitAction() {
  for (var _len6 = arguments.length, elements = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    elements[_key6] = arguments[_key6];
  }
  var action = getAttribute.apply(void 0, ["data-turbo-action"].concat(elements));
  return isAction(action) ? action : null;
}
function getMetaElement(name) {
  return document.querySelector("meta[name=\"".concat(name, "\"]"));
}
function getMetaContent(name) {
  var element = getMetaElement(name);
  return element && element.content;
}
function setMetaContent(name, content) {
  var element = getMetaElement(name);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
  return element;
}
function findClosestRecursively(element, selector) {
  var _a;
  if (element instanceof Element) {
    return element.closest(selector) || findClosestRecursively(element.assignedSlot || ((_a = element.getRootNode()) === null || _a === void 0 ? void 0 : _a.host), selector);
  }
}
var FetchMethod;
(function (FetchMethod) {
  FetchMethod[FetchMethod["get"] = 0] = "get";
  FetchMethod[FetchMethod["post"] = 1] = "post";
  FetchMethod[FetchMethod["put"] = 2] = "put";
  FetchMethod[FetchMethod["patch"] = 3] = "patch";
  FetchMethod[FetchMethod["delete"] = 4] = "delete";
})(FetchMethod || (FetchMethod = {}));
function fetchMethodFromString(method) {
  switch (method.toLowerCase()) {
    case "get":
      return FetchMethod.get;
    case "post":
      return FetchMethod.post;
    case "put":
      return FetchMethod.put;
    case "patch":
      return FetchMethod.patch;
    case "delete":
      return FetchMethod["delete"];
  }
}
var FetchRequest = /*#__PURE__*/function () {
  function FetchRequest(delegate, method, location) {
    var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new URLSearchParams();
    var target = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    _classCallCheck(this, FetchRequest);
    this.abortController = new AbortController();
    this.resolveRequestPromise = function (_value) {};
    this.delegate = delegate;
    this.method = method;
    this.headers = this.defaultHeaders;
    this.body = body;
    this.url = location;
    this.target = target;
  }
  return _createClass(FetchRequest, [{
    key: "location",
    get: function get() {
      return this.url;
    }
  }, {
    key: "params",
    get: function get() {
      return this.url.searchParams;
    }
  }, {
    key: "entries",
    get: function get() {
      return this.body ? Array.from(this.body.entries()) : [];
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.abortController.abort();
    }
  }, {
    key: "perform",
    value: function () {
      var _perform = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var fetchOptions, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              fetchOptions = this.fetchOptions;
              this.delegate.prepareRequest(this);
              _context.n = 1;
              return this.allowRequestToBeIntercepted(fetchOptions);
            case 1:
              _context.p = 1;
              this.delegate.requestStarted(this);
              _context.n = 2;
              return fetch(this.url.href, fetchOptions);
            case 2:
              response = _context.v;
              _context.n = 3;
              return this.receive(response);
            case 3:
              return _context.a(2, _context.v);
            case 4:
              _context.p = 4;
              _t = _context.v;
              if (!(_t.name !== "AbortError")) {
                _context.n = 5;
                break;
              }
              if (this.willDelegateErrorHandling(_t)) {
                this.delegate.requestErrored(this, _t);
              }
              throw _t;
            case 5:
              _context.p = 5;
              this.delegate.requestFinished(this);
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function perform() {
        return _perform.apply(this, arguments);
      }
      return perform;
    }()
  }, {
    key: "receive",
    value: function () {
      var _receive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(response) {
        var fetchResponse, event;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              fetchResponse = new FetchResponse(response);
              event = dispatch("turbo:before-fetch-response", {
                cancelable: true,
                detail: {
                  fetchResponse: fetchResponse
                },
                target: this.target
              });
              if (event.defaultPrevented) {
                this.delegate.requestPreventedHandlingResponse(this, fetchResponse);
              } else if (fetchResponse.succeeded) {
                this.delegate.requestSucceededWithResponse(this, fetchResponse);
              } else {
                this.delegate.requestFailedWithResponse(this, fetchResponse);
              }
              return _context2.a(2, fetchResponse);
          }
        }, _callee2, this);
      }));
      function receive(_x) {
        return _receive.apply(this, arguments);
      }
      return receive;
    }()
  }, {
    key: "fetchOptions",
    get: function get() {
      var _a;
      return {
        method: FetchMethod[this.method].toUpperCase(),
        credentials: "same-origin",
        headers: this.headers,
        redirect: "follow",
        body: this.isSafe ? null : this.body,
        signal: this.abortSignal,
        referrer: (_a = this.delegate.referrer) === null || _a === void 0 ? void 0 : _a.href
      };
    }
  }, {
    key: "defaultHeaders",
    get: function get() {
      return {
        Accept: "text/html, application/xhtml+xml"
      };
    }
  }, {
    key: "isSafe",
    get: function get() {
      return this.method === FetchMethod.get;
    }
  }, {
    key: "abortSignal",
    get: function get() {
      return this.abortController.signal;
    }
  }, {
    key: "acceptResponseType",
    value: function acceptResponseType(mimeType) {
      this.headers["Accept"] = [mimeType, this.headers["Accept"]].join(", ");
    }
  }, {
    key: "allowRequestToBeIntercepted",
    value: function () {
      var _allowRequestToBeIntercepted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(fetchOptions) {
        var _this2 = this;
        var requestInterception, event;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              requestInterception = new Promise(function (resolve) {
                return _this2.resolveRequestPromise = resolve;
              });
              event = dispatch("turbo:before-fetch-request", {
                cancelable: true,
                detail: {
                  fetchOptions: fetchOptions,
                  url: this.url,
                  resume: this.resolveRequestPromise
                },
                target: this.target
              });
              if (!event.defaultPrevented) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return requestInterception;
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function allowRequestToBeIntercepted(_x2) {
        return _allowRequestToBeIntercepted.apply(this, arguments);
      }
      return allowRequestToBeIntercepted;
    }()
  }, {
    key: "willDelegateErrorHandling",
    value: function willDelegateErrorHandling(error) {
      var event = dispatch("turbo:fetch-request-error", {
        target: this.target,
        cancelable: true,
        detail: {
          request: this,
          error: error
        }
      });
      return !event.defaultPrevented;
    }
  }]);
}();
var AppearanceObserver = /*#__PURE__*/function () {
  function AppearanceObserver(delegate, element) {
    var _this3 = this;
    _classCallCheck(this, AppearanceObserver);
    this.started = false;
    this.intersect = function (entries) {
      var lastEntry = entries.slice(-1)[0];
      if (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.isIntersecting) {
        _this3.delegate.elementAppearedInViewport(_this3.element);
      }
    };
    this.delegate = delegate;
    this.element = element;
    this.intersectionObserver = new IntersectionObserver(this.intersect);
  }
  return _createClass(AppearanceObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.started = true;
        this.intersectionObserver.observe(this.element);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.started = false;
        this.intersectionObserver.unobserve(this.element);
      }
    }
  }]);
}();
var StreamMessage = /*#__PURE__*/function () {
  function StreamMessage(fragment) {
    _classCallCheck(this, StreamMessage);
    this.fragment = importStreamElements(fragment);
  }
  return _createClass(StreamMessage, null, [{
    key: "wrap",
    value: function wrap(message) {
      if (typeof message == "string") {
        return new this(createDocumentFragment(message));
      } else {
        return message;
      }
    }
  }]);
}();
StreamMessage.contentType = "text/vnd.turbo-stream.html";
function importStreamElements(fragment) {
  var _iterator3 = _createForOfIteratorHelper(fragment.querySelectorAll("turbo-stream")),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var element = _step3.value;
      var streamElement = document.importNode(element, true);
      var _iterator4 = _createForOfIteratorHelper(streamElement.templateElement.content.querySelectorAll("script")),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var inertScriptElement = _step4.value;
          inertScriptElement.replaceWith(activateScriptElement(inertScriptElement));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      element.replaceWith(streamElement);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return fragment;
}
var FormSubmissionState;
(function (FormSubmissionState) {
  FormSubmissionState[FormSubmissionState["initialized"] = 0] = "initialized";
  FormSubmissionState[FormSubmissionState["requesting"] = 1] = "requesting";
  FormSubmissionState[FormSubmissionState["waiting"] = 2] = "waiting";
  FormSubmissionState[FormSubmissionState["receiving"] = 3] = "receiving";
  FormSubmissionState[FormSubmissionState["stopping"] = 4] = "stopping";
  FormSubmissionState[FormSubmissionState["stopped"] = 5] = "stopped";
})(FormSubmissionState || (FormSubmissionState = {}));
var FormEnctype;
(function (FormEnctype) {
  FormEnctype["urlEncoded"] = "application/x-www-form-urlencoded";
  FormEnctype["multipart"] = "multipart/form-data";
  FormEnctype["plain"] = "text/plain";
})(FormEnctype || (FormEnctype = {}));
function formEnctypeFromString(encoding) {
  switch (encoding.toLowerCase()) {
    case FormEnctype.multipart:
      return FormEnctype.multipart;
    case FormEnctype.plain:
      return FormEnctype.plain;
    default:
      return FormEnctype.urlEncoded;
  }
}
var FormSubmission = /*#__PURE__*/function () {
  function FormSubmission(delegate, formElement, submitter) {
    var mustRedirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    _classCallCheck(this, FormSubmission);
    this.state = FormSubmissionState.initialized;
    this.delegate = delegate;
    this.formElement = formElement;
    this.submitter = submitter;
    this.formData = buildFormData(formElement, submitter);
    this.location = expandURL(this.action);
    if (this.method == FetchMethod.get) {
      mergeFormDataEntries(this.location, _toConsumableArray(this.body.entries()));
    }
    this.fetchRequest = new FetchRequest(this, this.method, this.location, this.body, this.formElement);
    this.mustRedirect = mustRedirect;
  }
  return _createClass(FormSubmission, [{
    key: "method",
    get: function get() {
      var _a;
      var method = ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formmethod")) || this.formElement.getAttribute("method") || "";
      return fetchMethodFromString(method.toLowerCase()) || FetchMethod.get;
    }
  }, {
    key: "action",
    get: function get() {
      var _a;
      var formElementAction = typeof this.formElement.action === "string" ? this.formElement.action : null;
      if ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.hasAttribute("formaction")) {
        return this.submitter.getAttribute("formaction") || "";
      } else {
        return this.formElement.getAttribute("action") || formElementAction || "";
      }
    }
  }, {
    key: "body",
    get: function get() {
      if (this.enctype == FormEnctype.urlEncoded || this.method == FetchMethod.get) {
        return new URLSearchParams(this.stringFormData);
      } else {
        return this.formData;
      }
    }
  }, {
    key: "enctype",
    get: function get() {
      var _a;
      return formEnctypeFromString(((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formenctype")) || this.formElement.enctype);
    }
  }, {
    key: "isSafe",
    get: function get() {
      return this.fetchRequest.isSafe;
    }
  }, {
    key: "stringFormData",
    get: function get() {
      return _toConsumableArray(this.formData).reduce(function (entries, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          name = _ref4[0],
          value = _ref4[1];
        return entries.concat(typeof value == "string" ? [[name, value]] : []);
      }, []);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _FormSubmissionState, initialized, requesting, confirmationMessage, answer;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _FormSubmissionState = FormSubmissionState, initialized = _FormSubmissionState.initialized, requesting = _FormSubmissionState.requesting;
              confirmationMessage = getAttribute("data-turbo-confirm", this.submitter, this.formElement);
              if (!(typeof confirmationMessage === "string")) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return FormSubmission.confirmMethod(confirmationMessage, this.formElement, this.submitter);
            case 1:
              answer = _context4.v;
              if (answer) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              if (!(this.state == initialized)) {
                _context4.n = 3;
                break;
              }
              this.state = requesting;
              return _context4.a(2, this.fetchRequest.perform());
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      var _FormSubmissionState2 = FormSubmissionState,
        stopping = _FormSubmissionState2.stopping,
        stopped = _FormSubmissionState2.stopped;
      if (this.state != stopping && this.state != stopped) {
        this.state = stopping;
        this.fetchRequest.cancel();
        return true;
      }
    }
  }, {
    key: "prepareRequest",
    value: function prepareRequest(request) {
      if (!request.isSafe) {
        var token = getCookieValue(getMetaContent("csrf-param")) || getMetaContent("csrf-token");
        if (token) {
          request.headers["X-CSRF-Token"] = token;
        }
      }
      if (this.requestAcceptsTurboStreamResponse(request)) {
        request.acceptResponseType(StreamMessage.contentType);
      }
    }
  }, {
    key: "requestStarted",
    value: function requestStarted(_request) {
      var _a;
      this.state = FormSubmissionState.waiting;
      (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.setAttribute("disabled", "");
      this.setSubmitsWith();
      dispatch("turbo:submit-start", {
        target: this.formElement,
        detail: {
          formSubmission: this
        }
      });
      this.delegate.formSubmissionStarted(this);
    }
  }, {
    key: "requestPreventedHandlingResponse",
    value: function requestPreventedHandlingResponse(request, response) {
      this.result = {
        success: response.succeeded,
        fetchResponse: response
      };
    }
  }, {
    key: "requestSucceededWithResponse",
    value: function requestSucceededWithResponse(request, response) {
      if (response.clientError || response.serverError) {
        this.delegate.formSubmissionFailedWithResponse(this, response);
      } else if (this.requestMustRedirect(request) && responseSucceededWithoutRedirect(response)) {
        var error = new Error("Form responses must redirect to another location");
        this.delegate.formSubmissionErrored(this, error);
      } else {
        this.state = FormSubmissionState.receiving;
        this.result = {
          success: true,
          fetchResponse: response
        };
        this.delegate.formSubmissionSucceededWithResponse(this, response);
      }
    }
  }, {
    key: "requestFailedWithResponse",
    value: function requestFailedWithResponse(request, response) {
      this.result = {
        success: false,
        fetchResponse: response
      };
      this.delegate.formSubmissionFailedWithResponse(this, response);
    }
  }, {
    key: "requestErrored",
    value: function requestErrored(request, error) {
      this.result = {
        success: false,
        error: error
      };
      this.delegate.formSubmissionErrored(this, error);
    }
  }, {
    key: "requestFinished",
    value: function requestFinished(_request) {
      var _a;
      this.state = FormSubmissionState.stopped;
      (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.removeAttribute("disabled");
      this.resetSubmitterText();
      dispatch("turbo:submit-end", {
        target: this.formElement,
        detail: Object.assign({
          formSubmission: this
        }, this.result)
      });
      this.delegate.formSubmissionFinished(this);
    }
  }, {
    key: "setSubmitsWith",
    value: function setSubmitsWith() {
      if (!this.submitter || !this.submitsWith) return;
      if (this.submitter.matches("button")) {
        this.originalSubmitText = this.submitter.innerHTML;
        this.submitter.innerHTML = this.submitsWith;
      } else if (this.submitter.matches("input")) {
        var input = this.submitter;
        this.originalSubmitText = input.value;
        input.value = this.submitsWith;
      }
    }
  }, {
    key: "resetSubmitterText",
    value: function resetSubmitterText() {
      if (!this.submitter || !this.originalSubmitText) return;
      if (this.submitter.matches("button")) {
        this.submitter.innerHTML = this.originalSubmitText;
      } else if (this.submitter.matches("input")) {
        var input = this.submitter;
        input.value = this.originalSubmitText;
      }
    }
  }, {
    key: "requestMustRedirect",
    value: function requestMustRedirect(request) {
      return !request.isSafe && this.mustRedirect;
    }
  }, {
    key: "requestAcceptsTurboStreamResponse",
    value: function requestAcceptsTurboStreamResponse(request) {
      return !request.isSafe || hasAttribute("data-turbo-stream", this.submitter, this.formElement);
    }
  }, {
    key: "submitsWith",
    get: function get() {
      var _a;
      return (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("data-turbo-submits-with");
    }
  }], [{
    key: "confirmMethod",
    value: function confirmMethod(message, _element, _submitter) {
      return Promise.resolve(confirm(message));
    }
  }]);
}();
function buildFormData(formElement, submitter) {
  var formData = new FormData(formElement);
  var name = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("name");
  var value = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("value");
  if (name) {
    formData.append(name, value || "");
  }
  return formData;
}
function getCookieValue(cookieName) {
  if (cookieName != null) {
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var cookie = cookies.find(function (cookie) {
      return cookie.startsWith(cookieName);
    });
    if (cookie) {
      var value = cookie.split("=").slice(1).join("=");
      return value ? decodeURIComponent(value) : undefined;
    }
  }
}
function responseSucceededWithoutRedirect(response) {
  return response.statusCode == 200 && !response.redirected;
}
function mergeFormDataEntries(url, entries) {
  var searchParams = new URLSearchParams();
  var _iterator5 = _createForOfIteratorHelper(entries),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _ref5 = _step5.value;
      var _ref6 = _slicedToArray(_ref5, 2);
      var name = _ref6[0];
      var value = _ref6[1];
      if (value instanceof File) continue;
      searchParams.append(name, value);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  url.search = searchParams.toString();
  return url;
}
var Snapshot = /*#__PURE__*/function () {
  function Snapshot(element) {
    _classCallCheck(this, Snapshot);
    this.element = element;
  }
  return _createClass(Snapshot, [{
    key: "activeElement",
    get: function get() {
      return this.element.ownerDocument.activeElement;
    }
  }, {
    key: "children",
    get: function get() {
      return _toConsumableArray(this.element.children);
    }
  }, {
    key: "hasAnchor",
    value: function hasAnchor(anchor) {
      return this.getElementForAnchor(anchor) != null;
    }
  }, {
    key: "getElementForAnchor",
    value: function getElementForAnchor(anchor) {
      return anchor ? this.element.querySelector("[id='".concat(anchor, "'], a[name='").concat(anchor, "']")) : null;
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this.element.isConnected;
    }
  }, {
    key: "firstAutofocusableElement",
    get: function get() {
      var inertDisabledOrHidden = "[inert], :disabled, [hidden], details:not([open]), dialog:not([open])";
      var _iterator6 = _createForOfIteratorHelper(this.element.querySelectorAll("[autofocus]")),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var element = _step6.value;
          if (element.closest(inertDisabledOrHidden) == null) return element;else continue;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return null;
    }
  }, {
    key: "permanentElements",
    get: function get() {
      return queryPermanentElementsAll(this.element);
    }
  }, {
    key: "getPermanentElementById",
    value: function getPermanentElementById(id) {
      return _getPermanentElementById(this.element, id);
    }
  }, {
    key: "getPermanentElementMapForSnapshot",
    value: function getPermanentElementMapForSnapshot(snapshot) {
      var permanentElementMap = {};
      var _iterator7 = _createForOfIteratorHelper(this.permanentElements),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var currentPermanentElement = _step7.value;
          var id = currentPermanentElement.id;
          var newPermanentElement = snapshot.getPermanentElementById(id);
          if (newPermanentElement) {
            permanentElementMap[id] = [currentPermanentElement, newPermanentElement];
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return permanentElementMap;
    }
  }]);
}();
function _getPermanentElementById(node, id) {
  return node.querySelector("#".concat(id, "[data-turbo-permanent]"));
}
function queryPermanentElementsAll(node) {
  return node.querySelectorAll("[id][data-turbo-permanent]");
}
var FormSubmitObserver = /*#__PURE__*/function () {
  function FormSubmitObserver(delegate, eventTarget) {
    var _this4 = this;
    _classCallCheck(this, FormSubmitObserver);
    this.started = false;
    this.submitCaptured = function () {
      _this4.eventTarget.removeEventListener("submit", _this4.submitBubbled, false);
      _this4.eventTarget.addEventListener("submit", _this4.submitBubbled, false);
    };
    this.submitBubbled = function (event) {
      if (!event.defaultPrevented) {
        var form = event.target instanceof HTMLFormElement ? event.target : undefined;
        var submitter = event.submitter || undefined;
        if (form && submissionDoesNotDismissDialog(form, submitter) && submissionDoesNotTargetIFrame(form, submitter) && _this4.delegate.willSubmitForm(form, submitter)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          _this4.delegate.formSubmitted(form, submitter);
        }
      }
    };
    this.delegate = delegate;
    this.eventTarget = eventTarget;
  }
  return _createClass(FormSubmitObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.eventTarget.addEventListener("submit", this.submitCaptured, true);
        this.started = true;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.eventTarget.removeEventListener("submit", this.submitCaptured, true);
        this.started = false;
      }
    }
  }]);
}();
function submissionDoesNotDismissDialog(form, submitter) {
  var method = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || form.getAttribute("method");
  return method != "dialog";
}
function submissionDoesNotTargetIFrame(form, submitter) {
  if ((submitter === null || submitter === void 0 ? void 0 : submitter.hasAttribute("formtarget")) || form.hasAttribute("target")) {
    var target = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formtarget")) || form.target;
    var _iterator8 = _createForOfIteratorHelper(document.getElementsByName(target)),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var element = _step8.value;
        if (element instanceof HTMLIFrameElement) return false;
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    return true;
  } else {
    return true;
  }
}
var View = /*#__PURE__*/function () {
  function View(delegate, element) {
    _classCallCheck(this, View);
    this.resolveRenderPromise = function (_value) {};
    this.resolveInterceptionPromise = function (_value) {};
    this.delegate = delegate;
    this.element = element;
  }
  return _createClass(View, [{
    key: "scrollToAnchor",
    value: function scrollToAnchor(anchor) {
      var element = this.snapshot.getElementForAnchor(anchor);
      if (element) {
        this.scrollToElement(element);
        this.focusElement(element);
      } else {
        this.scrollToPosition({
          x: 0,
          y: 0
        });
      }
    }
  }, {
    key: "scrollToAnchorFromLocation",
    value: function scrollToAnchorFromLocation(location) {
      this.scrollToAnchor(getAnchor(location));
    }
  }, {
    key: "scrollToElement",
    value: function scrollToElement(element) {
      element.scrollIntoView();
    }
  }, {
    key: "focusElement",
    value: function focusElement(element) {
      if (element instanceof HTMLElement) {
        if (element.hasAttribute("tabindex")) {
          element.focus();
        } else {
          element.setAttribute("tabindex", "-1");
          element.focus();
          element.removeAttribute("tabindex");
        }
      }
    }
  }, {
    key: "scrollToPosition",
    value: function scrollToPosition(_ref7) {
      var x = _ref7.x,
        y = _ref7.y;
      this.scrollRoot.scrollTo(x, y);
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      this.scrollToPosition({
        x: 0,
        y: 0
      });
    }
  }, {
    key: "scrollRoot",
    get: function get() {
      return window;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(renderer) {
        var _this5 = this;
        var isPreview, shouldRender, snapshot, renderInterception, options, immediateRender;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              isPreview = renderer.isPreview, shouldRender = renderer.shouldRender, snapshot = renderer.newSnapshot;
              if (!shouldRender) {
                _context5.n = 7;
                break;
              }
              _context5.p = 1;
              this.renderPromise = new Promise(function (resolve) {
                return _this5.resolveRenderPromise = resolve;
              });
              this.renderer = renderer;
              _context5.n = 2;
              return this.prepareToRenderSnapshot(renderer);
            case 2:
              renderInterception = new Promise(function (resolve) {
                return _this5.resolveInterceptionPromise = resolve;
              });
              options = {
                resume: this.resolveInterceptionPromise,
                render: this.renderer.renderElement
              };
              immediateRender = this.delegate.allowsImmediateRender(snapshot, options);
              if (immediateRender) {
                _context5.n = 3;
                break;
              }
              _context5.n = 3;
              return renderInterception;
            case 3:
              _context5.n = 4;
              return this.renderSnapshot(renderer);
            case 4:
              this.delegate.viewRenderedSnapshot(snapshot, isPreview);
              this.delegate.preloadOnLoadLinksForView(this.element);
              this.finishRenderingSnapshot(renderer);
            case 5:
              _context5.p = 5;
              delete this.renderer;
              this.resolveRenderPromise(undefined);
              delete this.renderPromise;
              return _context5.f(5);
            case 6:
              _context5.n = 8;
              break;
            case 7:
              this.invalidate(renderer.reloadReason);
            case 8:
              return _context5.a(2);
          }
        }, _callee5, this, [[1,, 5, 6]]);
      }));
      function render(_x3) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "invalidate",
    value: function invalidate(reason) {
      this.delegate.viewInvalidated(reason);
    }
  }, {
    key: "prepareToRenderSnapshot",
    value: function () {
      var _prepareToRenderSnapshot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(renderer) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.markAsPreview(renderer.isPreview);
              _context6.n = 1;
              return renderer.prepareToRender();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function prepareToRenderSnapshot(_x4) {
        return _prepareToRenderSnapshot.apply(this, arguments);
      }
      return prepareToRenderSnapshot;
    }()
  }, {
    key: "markAsPreview",
    value: function markAsPreview(isPreview) {
      if (isPreview) {
        this.element.setAttribute("data-turbo-preview", "");
      } else {
        this.element.removeAttribute("data-turbo-preview");
      }
    }
  }, {
    key: "renderSnapshot",
    value: function () {
      var _renderSnapshot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(renderer) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return renderer.render();
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }));
      function renderSnapshot(_x5) {
        return _renderSnapshot.apply(this, arguments);
      }
      return renderSnapshot;
    }()
  }, {
    key: "finishRenderingSnapshot",
    value: function finishRenderingSnapshot(renderer) {
      renderer.finishRendering();
    }
  }]);
}();
var FrameView = /*#__PURE__*/function (_View) {
  function FrameView() {
    _classCallCheck(this, FrameView);
    return _callSuper(this, FrameView, arguments);
  }
  _inherits(FrameView, _View);
  return _createClass(FrameView, [{
    key: "missing",
    value: function missing() {
      this.element.innerHTML = "<strong class=\"turbo-frame-error\">Content missing</strong>";
    }
  }, {
    key: "snapshot",
    get: function get() {
      return new Snapshot(this.element);
    }
  }]);
}(View);
var LinkInterceptor = /*#__PURE__*/function () {
  function LinkInterceptor(delegate, element) {
    var _this6 = this;
    _classCallCheck(this, LinkInterceptor);
    this.clickBubbled = function (event) {
      if (_this6.respondsToEventTarget(event.target)) {
        _this6.clickEvent = event;
      } else {
        delete _this6.clickEvent;
      }
    };
    this.linkClicked = function (event) {
      if (_this6.clickEvent && _this6.respondsToEventTarget(event.target) && event.target instanceof Element) {
        if (_this6.delegate.shouldInterceptLinkClick(event.target, event.detail.url, event.detail.originalEvent)) {
          _this6.clickEvent.preventDefault();
          event.preventDefault();
          _this6.delegate.linkClickIntercepted(event.target, event.detail.url, event.detail.originalEvent);
        }
      }
      delete _this6.clickEvent;
    };
    this.willVisit = function (_event) {
      delete _this6.clickEvent;
    };
    this.delegate = delegate;
    this.element = element;
  }
  return _createClass(LinkInterceptor, [{
    key: "start",
    value: function start() {
      this.element.addEventListener("click", this.clickBubbled);
      document.addEventListener("turbo:click", this.linkClicked);
      document.addEventListener("turbo:before-visit", this.willVisit);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.element.removeEventListener("click", this.clickBubbled);
      document.removeEventListener("turbo:click", this.linkClicked);
      document.removeEventListener("turbo:before-visit", this.willVisit);
    }
  }, {
    key: "respondsToEventTarget",
    value: function respondsToEventTarget(target) {
      var element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
      return element && element.closest("turbo-frame, html") == this.element;
    }
  }]);
}();
var LinkClickObserver = /*#__PURE__*/function () {
  function LinkClickObserver(delegate, eventTarget) {
    var _this7 = this;
    _classCallCheck(this, LinkClickObserver);
    this.started = false;
    this.clickCaptured = function () {
      _this7.eventTarget.removeEventListener("click", _this7.clickBubbled, false);
      _this7.eventTarget.addEventListener("click", _this7.clickBubbled, false);
    };
    this.clickBubbled = function (event) {
      if (event instanceof MouseEvent && _this7.clickEventIsSignificant(event)) {
        var target = event.composedPath && event.composedPath()[0] || event.target;
        var link = _this7.findLinkFromClickTarget(target);
        if (link && doesNotTargetIFrame(link)) {
          var _location2 = _this7.getLocationForLink(link);
          if (_this7.delegate.willFollowLinkToLocation(link, _location2, event)) {
            event.preventDefault();
            _this7.delegate.followedLinkToLocation(link, _location2);
          }
        }
      }
    };
    this.delegate = delegate;
    this.eventTarget = eventTarget;
  }
  return _createClass(LinkClickObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.eventTarget.addEventListener("click", this.clickCaptured, true);
        this.started = true;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.eventTarget.removeEventListener("click", this.clickCaptured, true);
        this.started = false;
      }
    }
  }, {
    key: "clickEventIsSignificant",
    value: function clickEventIsSignificant(event) {
      return !(event.target && event.target.isContentEditable || event.defaultPrevented || event.which > 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
    }
  }, {
    key: "findLinkFromClickTarget",
    value: function findLinkFromClickTarget(target) {
      return findClosestRecursively(target, "a[href]:not([target^=_]):not([download])");
    }
  }, {
    key: "getLocationForLink",
    value: function getLocationForLink(link) {
      return expandURL(link.getAttribute("href") || "");
    }
  }]);
}();
function doesNotTargetIFrame(anchor) {
  if (anchor.hasAttribute("target")) {
    var _iterator9 = _createForOfIteratorHelper(document.getElementsByName(anchor.target)),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var element = _step9.value;
        if (element instanceof HTMLIFrameElement) return false;
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
    return true;
  } else {
    return true;
  }
}
var FormLinkClickObserver = /*#__PURE__*/function () {
  function FormLinkClickObserver(delegate, element) {
    _classCallCheck(this, FormLinkClickObserver);
    this.delegate = delegate;
    this.linkInterceptor = new LinkClickObserver(this, element);
  }
  return _createClass(FormLinkClickObserver, [{
    key: "start",
    value: function start() {
      this.linkInterceptor.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.linkInterceptor.stop();
    }
  }, {
    key: "willFollowLinkToLocation",
    value: function willFollowLinkToLocation(link, location, originalEvent) {
      return this.delegate.willSubmitFormLinkToLocation(link, location, originalEvent) && link.hasAttribute("data-turbo-method");
    }
  }, {
    key: "followedLinkToLocation",
    value: function followedLinkToLocation(link, location) {
      var form = document.createElement("form");
      var type = "hidden";
      var _iterator0 = _createForOfIteratorHelper(location.searchParams),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var _ref8 = _step0.value;
          var _ref9 = _slicedToArray(_ref8, 2);
          var name = _ref9[0];
          var value = _ref9[1];
          form.append(Object.assign(document.createElement("input"), {
            type: type,
            name: name,
            value: value
          }));
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      var action = Object.assign(location, {
        search: ""
      });
      form.setAttribute("data-turbo", "true");
      form.setAttribute("action", action.href);
      form.setAttribute("hidden", "");
      var method = link.getAttribute("data-turbo-method");
      if (method) form.setAttribute("method", method);
      var turboFrame = link.getAttribute("data-turbo-frame");
      if (turboFrame) form.setAttribute("data-turbo-frame", turboFrame);
      var turboAction = getVisitAction(link);
      if (turboAction) form.setAttribute("data-turbo-action", turboAction);
      var turboConfirm = link.getAttribute("data-turbo-confirm");
      if (turboConfirm) form.setAttribute("data-turbo-confirm", turboConfirm);
      var turboStream = link.hasAttribute("data-turbo-stream");
      if (turboStream) form.setAttribute("data-turbo-stream", "");
      this.delegate.submittedFormLinkToLocation(link, location, form);
      document.body.appendChild(form);
      form.addEventListener("turbo:submit-end", function () {
        return form.remove();
      }, {
        once: true
      });
      requestAnimationFrame(function () {
        return form.requestSubmit();
      });
    }
  }]);
}();
var Bardo = /*#__PURE__*/function () {
  function Bardo(delegate, permanentElementMap) {
    _classCallCheck(this, Bardo);
    this.delegate = delegate;
    this.permanentElementMap = permanentElementMap;
  }
  return _createClass(Bardo, [{
    key: "enter",
    value: function enter() {
      for (var id in this.permanentElementMap) {
        var _this$permanentElemen = _slicedToArray(this.permanentElementMap[id], 2),
          currentPermanentElement = _this$permanentElemen[0],
          newPermanentElement = _this$permanentElemen[1];
        this.delegate.enteringBardo(currentPermanentElement, newPermanentElement);
        this.replaceNewPermanentElementWithPlaceholder(newPermanentElement);
      }
    }
  }, {
    key: "leave",
    value: function leave() {
      for (var id in this.permanentElementMap) {
        var _this$permanentElemen2 = _slicedToArray(this.permanentElementMap[id], 1),
          currentPermanentElement = _this$permanentElemen2[0];
        this.replaceCurrentPermanentElementWithClone(currentPermanentElement);
        this.replacePlaceholderWithPermanentElement(currentPermanentElement);
        this.delegate.leavingBardo(currentPermanentElement);
      }
    }
  }, {
    key: "replaceNewPermanentElementWithPlaceholder",
    value: function replaceNewPermanentElementWithPlaceholder(permanentElement) {
      var placeholder = createPlaceholderForPermanentElement(permanentElement);
      permanentElement.replaceWith(placeholder);
    }
  }, {
    key: "replaceCurrentPermanentElementWithClone",
    value: function replaceCurrentPermanentElementWithClone(permanentElement) {
      var clone = permanentElement.cloneNode(true);
      permanentElement.replaceWith(clone);
    }
  }, {
    key: "replacePlaceholderWithPermanentElement",
    value: function replacePlaceholderWithPermanentElement(permanentElement) {
      var placeholder = this.getPlaceholderById(permanentElement.id);
      placeholder === null || placeholder === void 0 ? void 0 : placeholder.replaceWith(permanentElement);
    }
  }, {
    key: "getPlaceholderById",
    value: function getPlaceholderById(id) {
      return this.placeholders.find(function (element) {
        return element.content == id;
      });
    }
  }, {
    key: "placeholders",
    get: function get() {
      return _toConsumableArray(document.querySelectorAll("meta[name=turbo-permanent-placeholder][content]"));
    }
  }], [{
    key: "preservingPermanentElements",
    value: function () {
      var _preservingPermanentElements = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(delegate, permanentElementMap, callback) {
        var bardo;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              bardo = new this(delegate, permanentElementMap);
              bardo.enter();
              _context8.n = 1;
              return callback();
            case 1:
              bardo.leave();
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function preservingPermanentElements(_x6, _x7, _x8) {
        return _preservingPermanentElements.apply(this, arguments);
      }
      return preservingPermanentElements;
    }()
  }]);
}();
function createPlaceholderForPermanentElement(permanentElement) {
  var element = document.createElement("meta");
  element.setAttribute("name", "turbo-permanent-placeholder");
  element.setAttribute("content", permanentElement.id);
  return element;
}
var Renderer = /*#__PURE__*/function () {
  function Renderer(currentSnapshot, newSnapshot, renderElement, isPreview) {
    var _this8 = this;
    var willRender = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    _classCallCheck(this, Renderer);
    this.activeElement = null;
    this.currentSnapshot = currentSnapshot;
    this.newSnapshot = newSnapshot;
    this.isPreview = isPreview;
    this.willRender = willRender;
    this.renderElement = renderElement;
    this.promise = new Promise(function (resolve, reject) {
      return _this8.resolvingFunctions = {
        resolve: resolve,
        reject: reject
      };
    });
  }
  return _createClass(Renderer, [{
    key: "shouldRender",
    get: function get() {
      return true;
    }
  }, {
    key: "reloadReason",
    get: function get() {
      return;
    }
  }, {
    key: "prepareToRender",
    value: function prepareToRender() {
      return;
    }
  }, {
    key: "finishRendering",
    value: function finishRendering() {
      if (this.resolvingFunctions) {
        this.resolvingFunctions.resolve();
        delete this.resolvingFunctions;
      }
    }
  }, {
    key: "preservingPermanentElements",
    value: function () {
      var _preservingPermanentElements2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(callback) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return Bardo.preservingPermanentElements(this, this.permanentElementMap, callback);
            case 1:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function preservingPermanentElements(_x9) {
        return _preservingPermanentElements2.apply(this, arguments);
      }
      return preservingPermanentElements;
    }()
  }, {
    key: "focusFirstAutofocusableElement",
    value: function focusFirstAutofocusableElement() {
      var element = this.connectedSnapshot.firstAutofocusableElement;
      if (elementIsFocusable(element)) {
        element.focus();
      }
    }
  }, {
    key: "enteringBardo",
    value: function enteringBardo(currentPermanentElement) {
      if (this.activeElement) return;
      if (currentPermanentElement.contains(this.currentSnapshot.activeElement)) {
        this.activeElement = this.currentSnapshot.activeElement;
      }
    }
  }, {
    key: "leavingBardo",
    value: function leavingBardo(currentPermanentElement) {
      if (currentPermanentElement.contains(this.activeElement) && this.activeElement instanceof HTMLElement) {
        this.activeElement.focus();
        this.activeElement = null;
      }
    }
  }, {
    key: "connectedSnapshot",
    get: function get() {
      return this.newSnapshot.isConnected ? this.newSnapshot : this.currentSnapshot;
    }
  }, {
    key: "currentElement",
    get: function get() {
      return this.currentSnapshot.element;
    }
  }, {
    key: "newElement",
    get: function get() {
      return this.newSnapshot.element;
    }
  }, {
    key: "permanentElementMap",
    get: function get() {
      return this.currentSnapshot.getPermanentElementMapForSnapshot(this.newSnapshot);
    }
  }]);
}();
function elementIsFocusable(element) {
  return element && typeof element.focus == "function";
}
var FrameRenderer = /*#__PURE__*/function (_Renderer) {
  function FrameRenderer(delegate, currentSnapshot, newSnapshot, renderElement, isPreview) {
    var _this9;
    var willRender = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    _classCallCheck(this, FrameRenderer);
    _this9 = _callSuper(this, FrameRenderer, [currentSnapshot, newSnapshot, renderElement, isPreview, willRender]);
    _this9.delegate = delegate;
    return _this9;
  }
  _inherits(FrameRenderer, _Renderer);
  return _createClass(FrameRenderer, [{
    key: "shouldRender",
    get: function get() {
      return true;
    }
  }, {
    key: "render",
    value: function () {
      var _render2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _this0 = this;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return nextAnimationFrame();
            case 1:
              this.preservingPermanentElements(function () {
                _this0.loadFrameElement();
              });
              this.scrollFrameIntoView();
              _context0.n = 2;
              return nextAnimationFrame();
            case 2:
              this.focusFirstAutofocusableElement();
              _context0.n = 3;
              return nextAnimationFrame();
            case 3:
              this.activateScriptElements();
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function render() {
        return _render2.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "loadFrameElement",
    value: function loadFrameElement() {
      this.delegate.willRenderFrame(this.currentElement, this.newElement);
      this.renderElement(this.currentElement, this.newElement);
    }
  }, {
    key: "scrollFrameIntoView",
    value: function scrollFrameIntoView() {
      if (this.currentElement.autoscroll || this.newElement.autoscroll) {
        var element = this.currentElement.firstElementChild;
        var block = readScrollLogicalPosition(this.currentElement.getAttribute("data-autoscroll-block"), "end");
        var behavior = readScrollBehavior(this.currentElement.getAttribute("data-autoscroll-behavior"), "auto");
        if (element) {
          element.scrollIntoView({
            block: block,
            behavior: behavior
          });
          return true;
        }
      }
      return false;
    }
  }, {
    key: "activateScriptElements",
    value: function activateScriptElements() {
      var _iterator1 = _createForOfIteratorHelper(this.newScriptElements),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var inertScriptElement = _step1.value;
          var activatedScriptElement = activateScriptElement(inertScriptElement);
          inertScriptElement.replaceWith(activatedScriptElement);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
    }
  }, {
    key: "newScriptElements",
    get: function get() {
      return this.currentElement.querySelectorAll("script");
    }
  }], [{
    key: "renderElement",
    value: function renderElement(currentElement, newElement) {
      var _a;
      var destinationRange = document.createRange();
      destinationRange.selectNodeContents(currentElement);
      destinationRange.deleteContents();
      var frameElement = newElement;
      var sourceRange = (_a = frameElement.ownerDocument) === null || _a === void 0 ? void 0 : _a.createRange();
      if (sourceRange) {
        sourceRange.selectNodeContents(frameElement);
        currentElement.appendChild(sourceRange.extractContents());
      }
    }
  }]);
}(Renderer);
function readScrollLogicalPosition(value, defaultValue) {
  if (value == "end" || value == "start" || value == "center" || value == "nearest") {
    return value;
  } else {
    return defaultValue;
  }
}
function readScrollBehavior(value, defaultValue) {
  if (value == "auto" || value == "smooth") {
    return value;
  } else {
    return defaultValue;
  }
}
var ProgressBar = /*#__PURE__*/function () {
  function ProgressBar() {
    var _this1 = this;
    _classCallCheck(this, ProgressBar);
    this.hiding = false;
    this.value = 0;
    this.visible = false;
    this.trickle = function () {
      _this1.setValue(_this1.value + Math.random() / 100);
    };
    this.stylesheetElement = this.createStylesheetElement();
    this.progressElement = this.createProgressElement();
    this.installStylesheetElement();
    this.setValue(0);
  }
  return _createClass(ProgressBar, [{
    key: "show",
    value: function show() {
      if (!this.visible) {
        this.visible = true;
        this.installProgressElement();
        this.startTrickling();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this10 = this;
      if (this.visible && !this.hiding) {
        this.hiding = true;
        this.fadeProgressElement(function () {
          _this10.uninstallProgressElement();
          _this10.stopTrickling();
          _this10.visible = false;
          _this10.hiding = false;
        });
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.value = value;
      this.refresh();
    }
  }, {
    key: "installStylesheetElement",
    value: function installStylesheetElement() {
      document.head.insertBefore(this.stylesheetElement, document.head.firstChild);
    }
  }, {
    key: "installProgressElement",
    value: function installProgressElement() {
      this.progressElement.style.width = "0";
      this.progressElement.style.opacity = "1";
      document.documentElement.insertBefore(this.progressElement, document.body);
      this.refresh();
    }
  }, {
    key: "fadeProgressElement",
    value: function fadeProgressElement(callback) {
      this.progressElement.style.opacity = "0";
      setTimeout(callback, ProgressBar.animationDuration * 1.5);
    }
  }, {
    key: "uninstallProgressElement",
    value: function uninstallProgressElement() {
      if (this.progressElement.parentNode) {
        document.documentElement.removeChild(this.progressElement);
      }
    }
  }, {
    key: "startTrickling",
    value: function startTrickling() {
      if (!this.trickleInterval) {
        this.trickleInterval = window.setInterval(this.trickle, ProgressBar.animationDuration);
      }
    }
  }, {
    key: "stopTrickling",
    value: function stopTrickling() {
      window.clearInterval(this.trickleInterval);
      delete this.trickleInterval;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this11 = this;
      requestAnimationFrame(function () {
        _this11.progressElement.style.width = "".concat(10 + _this11.value * 90, "%");
      });
    }
  }, {
    key: "createStylesheetElement",
    value: function createStylesheetElement() {
      var element = document.createElement("style");
      element.type = "text/css";
      element.textContent = ProgressBar.defaultCSS;
      if (this.cspNonce) {
        element.nonce = this.cspNonce;
      }
      return element;
    }
  }, {
    key: "createProgressElement",
    value: function createProgressElement() {
      var element = document.createElement("div");
      element.className = "turbo-progress-bar";
      return element;
    }
  }, {
    key: "cspNonce",
    get: function get() {
      return getMetaContent("csp-nonce");
    }
  }], [{
    key: "defaultCSS",
    get: function get() {
      return unindent(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      .turbo-progress-bar {\n        position: fixed;\n        display: block;\n        top: 0;\n        left: 0;\n        height: 3px;\n        background: #0076ff;\n        z-index: 2147483647;\n        transition:\n          width ", "ms ease-out,\n          opacity ", "ms ", "ms ease-in;\n        transform: translate3d(0, 0, 0);\n      }\n    "])), ProgressBar.animationDuration, ProgressBar.animationDuration / 2, ProgressBar.animationDuration / 2);
    }
  }]);
}();
ProgressBar.animationDuration = 300;
var HeadSnapshot = /*#__PURE__*/function (_Snapshot) {
  function HeadSnapshot() {
    var _this12;
    _classCallCheck(this, HeadSnapshot);
    _this12 = _callSuper(this, HeadSnapshot, arguments);
    _this12.detailsByOuterHTML = _this12.children.filter(function (element) {
      return !elementIsNoscript(element);
    }).map(function (element) {
      return elementWithoutNonce(element);
    }).reduce(function (result, element) {
      var outerHTML = element.outerHTML;
      var details = outerHTML in result ? result[outerHTML] : {
        type: elementType(element),
        tracked: elementIsTracked(element),
        elements: []
      };
      return Object.assign(Object.assign({}, result), _defineProperty({}, outerHTML, Object.assign(Object.assign({}, details), {
        elements: [].concat(_toConsumableArray(details.elements), [element])
      })));
    }, {});
    return _this12;
  }
  _inherits(HeadSnapshot, _Snapshot);
  return _createClass(HeadSnapshot, [{
    key: "trackedElementSignature",
    get: function get() {
      var _this13 = this;
      return Object.keys(this.detailsByOuterHTML).filter(function (outerHTML) {
        return _this13.detailsByOuterHTML[outerHTML].tracked;
      }).join("");
    }
  }, {
    key: "getScriptElementsNotInSnapshot",
    value: function getScriptElementsNotInSnapshot(snapshot) {
      return this.getElementsMatchingTypeNotInSnapshot("script", snapshot);
    }
  }, {
    key: "getStylesheetElementsNotInSnapshot",
    value: function getStylesheetElementsNotInSnapshot(snapshot) {
      return this.getElementsMatchingTypeNotInSnapshot("stylesheet", snapshot);
    }
  }, {
    key: "getElementsMatchingTypeNotInSnapshot",
    value: function getElementsMatchingTypeNotInSnapshot(matchedType, snapshot) {
      var _this14 = this;
      return Object.keys(this.detailsByOuterHTML).filter(function (outerHTML) {
        return !(outerHTML in snapshot.detailsByOuterHTML);
      }).map(function (outerHTML) {
        return _this14.detailsByOuterHTML[outerHTML];
      }).filter(function (_ref0) {
        var type = _ref0.type;
        return type == matchedType;
      }).map(function (_ref1) {
        var _ref1$elements = _slicedToArray(_ref1.elements, 1),
          element = _ref1$elements[0];
        return element;
      });
    }
  }, {
    key: "provisionalElements",
    get: function get() {
      var _this15 = this;
      return Object.keys(this.detailsByOuterHTML).reduce(function (result, outerHTML) {
        var _this15$detailsByOute = _this15.detailsByOuterHTML[outerHTML],
          type = _this15$detailsByOute.type,
          tracked = _this15$detailsByOute.tracked,
          elements = _this15$detailsByOute.elements;
        if (type == null && !tracked) {
          return [].concat(_toConsumableArray(result), _toConsumableArray(elements));
        } else if (elements.length > 1) {
          return [].concat(_toConsumableArray(result), _toConsumableArray(elements.slice(1)));
        } else {
          return result;
        }
      }, []);
    }
  }, {
    key: "getMetaValue",
    value: function getMetaValue(name) {
      var element = this.findMetaElementByName(name);
      return element ? element.getAttribute("content") : null;
    }
  }, {
    key: "findMetaElementByName",
    value: function findMetaElementByName(name) {
      var _this16 = this;
      return Object.keys(this.detailsByOuterHTML).reduce(function (result, outerHTML) {
        var _this16$detailsByOute = _slicedToArray(_this16.detailsByOuterHTML[outerHTML].elements, 1),
          element = _this16$detailsByOute[0];
        return elementIsMetaElementWithName(element, name) ? element : result;
      }, undefined);
    }
  }]);
}(Snapshot);
function elementType(element) {
  if (elementIsScript(element)) {
    return "script";
  } else if (elementIsStylesheet(element)) {
    return "stylesheet";
  }
}
function elementIsTracked(element) {
  return element.getAttribute("data-turbo-track") == "reload";
}
function elementIsScript(element) {
  var tagName = element.localName;
  return tagName == "script";
}
function elementIsNoscript(element) {
  var tagName = element.localName;
  return tagName == "noscript";
}
function elementIsStylesheet(element) {
  var tagName = element.localName;
  return tagName == "style" || tagName == "link" && element.getAttribute("rel") == "stylesheet";
}
function elementIsMetaElementWithName(element, name) {
  var tagName = element.localName;
  return tagName == "meta" && element.getAttribute("name") == name;
}
function elementWithoutNonce(element) {
  if (element.hasAttribute("nonce")) {
    element.setAttribute("nonce", "");
  }
  return element;
}
var PageSnapshot = /*#__PURE__*/function (_Snapshot2) {
  function PageSnapshot(element, headSnapshot) {
    var _this17;
    _classCallCheck(this, PageSnapshot);
    _this17 = _callSuper(this, PageSnapshot, [element]);
    _this17.headSnapshot = headSnapshot;
    return _this17;
  }
  _inherits(PageSnapshot, _Snapshot2);
  return _createClass(PageSnapshot, [{
    key: "clone",
    value: function clone() {
      var clonedElement = this.element.cloneNode(true);
      var selectElements = this.element.querySelectorAll("select");
      var clonedSelectElements = clonedElement.querySelectorAll("select");
      var _iterator10 = _createForOfIteratorHelper(selectElements.entries()),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _ref10 = _step10.value;
          var _ref11 = _slicedToArray(_ref10, 2);
          var index = _ref11[0];
          var source = _ref11[1];
          {
            var _clone = clonedSelectElements[index];
            var _iterator12 = _createForOfIteratorHelper(_clone.selectedOptions),
              _step12;
            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var option = _step12.value;
                option.selected = false;
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }
            var _iterator13 = _createForOfIteratorHelper(source.selectedOptions),
              _step13;
            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                var _option = _step13.value;
                _clone.options[_option.index].selected = true;
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      var _iterator11 = _createForOfIteratorHelper(clonedElement.querySelectorAll('input[type="password"]')),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var clonedPasswordInput = _step11.value;
          clonedPasswordInput.value = "";
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return new PageSnapshot(clonedElement, this.headSnapshot);
    }
  }, {
    key: "headElement",
    get: function get() {
      return this.headSnapshot.element;
    }
  }, {
    key: "rootLocation",
    get: function get() {
      var _a;
      var root = (_a = this.getSetting("root")) !== null && _a !== void 0 ? _a : "/";
      return expandURL(root);
    }
  }, {
    key: "cacheControlValue",
    get: function get() {
      return this.getSetting("cache-control");
    }
  }, {
    key: "isPreviewable",
    get: function get() {
      return this.cacheControlValue != "no-preview";
    }
  }, {
    key: "isCacheable",
    get: function get() {
      return this.cacheControlValue != "no-cache";
    }
  }, {
    key: "isVisitable",
    get: function get() {
      return this.getSetting("visit-control") != "reload";
    }
  }, {
    key: "getSetting",
    value: function getSetting(name) {
      return this.headSnapshot.getMetaValue("turbo-".concat(name));
    }
  }], [{
    key: "fromHTMLString",
    value: function fromHTMLString() {
      var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return this.fromDocument(parseHTMLDocument(html));
    }
  }, {
    key: "fromElement",
    value: function fromElement(element) {
      return this.fromDocument(element.ownerDocument);
    }
  }, {
    key: "fromDocument",
    value: function fromDocument(_ref12) {
      var head = _ref12.head,
        body = _ref12.body;
      return new this(body, new HeadSnapshot(head));
    }
  }]);
}(Snapshot);
var TimingMetric;
(function (TimingMetric) {
  TimingMetric["visitStart"] = "visitStart";
  TimingMetric["requestStart"] = "requestStart";
  TimingMetric["requestEnd"] = "requestEnd";
  TimingMetric["visitEnd"] = "visitEnd";
})(TimingMetric || (TimingMetric = {}));
var VisitState;
(function (VisitState) {
  VisitState["initialized"] = "initialized";
  VisitState["started"] = "started";
  VisitState["canceled"] = "canceled";
  VisitState["failed"] = "failed";
  VisitState["completed"] = "completed";
})(VisitState || (VisitState = {}));
var defaultOptions = {
  action: "advance",
  historyChanged: false,
  visitCachedSnapshot: function visitCachedSnapshot() {},
  willRender: true,
  updateHistory: true,
  shouldCacheSnapshot: true,
  acceptsStreamResponse: false
};
var SystemStatusCode;
(function (SystemStatusCode) {
  SystemStatusCode[SystemStatusCode["networkFailure"] = 0] = "networkFailure";
  SystemStatusCode[SystemStatusCode["timeoutFailure"] = -1] = "timeoutFailure";
  SystemStatusCode[SystemStatusCode["contentTypeMismatch"] = -2] = "contentTypeMismatch";
})(SystemStatusCode || (SystemStatusCode = {}));
var Visit = /*#__PURE__*/function () {
  function Visit(delegate, location, restorationIdentifier) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Visit);
    this.identifier = uuid();
    this.timingMetrics = {};
    this.followedRedirect = false;
    this.historyChanged = false;
    this.scrolled = false;
    this.shouldCacheSnapshot = true;
    this.acceptsStreamResponse = false;
    this.snapshotCached = false;
    this.state = VisitState.initialized;
    this.delegate = delegate;
    this.location = location;
    this.restorationIdentifier = restorationIdentifier || uuid();
    var _Object$assign2 = Object.assign(Object.assign({}, defaultOptions), options),
      action = _Object$assign2.action,
      historyChanged = _Object$assign2.historyChanged,
      referrer = _Object$assign2.referrer,
      snapshot = _Object$assign2.snapshot,
      snapshotHTML = _Object$assign2.snapshotHTML,
      response = _Object$assign2.response,
      visitCachedSnapshot = _Object$assign2.visitCachedSnapshot,
      willRender = _Object$assign2.willRender,
      updateHistory = _Object$assign2.updateHistory,
      shouldCacheSnapshot = _Object$assign2.shouldCacheSnapshot,
      acceptsStreamResponse = _Object$assign2.acceptsStreamResponse;
    this.action = action;
    this.historyChanged = historyChanged;
    this.referrer = referrer;
    this.snapshot = snapshot;
    this.snapshotHTML = snapshotHTML;
    this.response = response;
    this.isSamePage = this.delegate.locationWithActionIsSamePage(this.location, this.action);
    this.visitCachedSnapshot = visitCachedSnapshot;
    this.willRender = willRender;
    this.updateHistory = updateHistory;
    this.scrolled = !willRender;
    this.shouldCacheSnapshot = shouldCacheSnapshot;
    this.acceptsStreamResponse = acceptsStreamResponse;
  }
  return _createClass(Visit, [{
    key: "adapter",
    get: function get() {
      return this.delegate.adapter;
    }
  }, {
    key: "view",
    get: function get() {
      return this.delegate.view;
    }
  }, {
    key: "history",
    get: function get() {
      return this.delegate.history;
    }
  }, {
    key: "restorationData",
    get: function get() {
      return this.history.getRestorationDataForIdentifier(this.restorationIdentifier);
    }
  }, {
    key: "silent",
    get: function get() {
      return this.isSamePage;
    }
  }, {
    key: "start",
    value: function start() {
      if (this.state == VisitState.initialized) {
        this.recordTimingMetric(TimingMetric.visitStart);
        this.state = VisitState.started;
        this.adapter.visitStarted(this);
        this.delegate.visitStarted(this);
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.state == VisitState.started) {
        if (this.request) {
          this.request.cancel();
        }
        this.cancelRender();
        this.state = VisitState.canceled;
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      if (this.state == VisitState.started) {
        this.recordTimingMetric(TimingMetric.visitEnd);
        this.state = VisitState.completed;
        this.followRedirect();
        if (!this.followedRedirect) {
          this.adapter.visitCompleted(this);
          this.delegate.visitCompleted(this);
        }
      }
    }
  }, {
    key: "fail",
    value: function fail() {
      if (this.state == VisitState.started) {
        this.state = VisitState.failed;
        this.adapter.visitFailed(this);
      }
    }
  }, {
    key: "changeHistory",
    value: function changeHistory() {
      var _a;
      if (!this.historyChanged && this.updateHistory) {
        var actionForHistory = this.location.href === ((_a = this.referrer) === null || _a === void 0 ? void 0 : _a.href) ? "replace" : this.action;
        var method = getHistoryMethodForAction(actionForHistory);
        this.history.update(method, this.location, this.restorationIdentifier);
        this.historyChanged = true;
      }
    }
  }, {
    key: "issueRequest",
    value: function issueRequest() {
      if (this.hasPreloadedResponse()) {
        this.simulateRequest();
      } else if (this.shouldIssueRequest() && !this.request) {
        this.request = new FetchRequest(this, FetchMethod.get, this.location);
        this.request.perform();
      }
    }
  }, {
    key: "simulateRequest",
    value: function simulateRequest() {
      if (this.response) {
        this.startRequest();
        this.recordResponse();
        this.finishRequest();
      }
    }
  }, {
    key: "startRequest",
    value: function startRequest() {
      this.recordTimingMetric(TimingMetric.requestStart);
      this.adapter.visitRequestStarted(this);
    }
  }, {
    key: "recordResponse",
    value: function recordResponse() {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.response;
      this.response = response;
      if (response) {
        var statusCode = response.statusCode;
        if (isSuccessful(statusCode)) {
          this.adapter.visitRequestCompleted(this);
        } else {
          this.adapter.visitRequestFailedWithStatusCode(this, statusCode);
        }
      }
    }
  }, {
    key: "finishRequest",
    value: function finishRequest() {
      this.recordTimingMetric(TimingMetric.requestEnd);
      this.adapter.visitRequestFinished(this);
    }
  }, {
    key: "loadResponse",
    value: function loadResponse() {
      var _this18 = this;
      if (this.response) {
        var _this$response = this.response,
          statusCode = _this$response.statusCode,
          responseHTML = _this$response.responseHTML;
        this.render(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                if (_this18.shouldCacheSnapshot) _this18.cacheSnapshot();
                if (!_this18.view.renderPromise) {
                  _context1.n = 1;
                  break;
                }
                _context1.n = 1;
                return _this18.view.renderPromise;
              case 1:
                if (!(isSuccessful(statusCode) && responseHTML != null)) {
                  _context1.n = 3;
                  break;
                }
                _context1.n = 2;
                return _this18.view.renderPage(PageSnapshot.fromHTMLString(responseHTML), false, _this18.willRender, _this18);
              case 2:
                _this18.performScroll();
                _this18.adapter.visitRendered(_this18);
                _this18.complete();
                _context1.n = 5;
                break;
              case 3:
                _context1.n = 4;
                return _this18.view.renderError(PageSnapshot.fromHTMLString(responseHTML), _this18);
              case 4:
                _this18.adapter.visitRendered(_this18);
                _this18.fail();
              case 5:
                return _context1.a(2);
            }
          }, _callee1);
        })));
      }
    }
  }, {
    key: "getCachedSnapshot",
    value: function getCachedSnapshot() {
      var snapshot = this.view.getCachedSnapshotForLocation(this.location) || this.getPreloadedSnapshot();
      if (snapshot && (!getAnchor(this.location) || snapshot.hasAnchor(getAnchor(this.location)))) {
        if (this.action == "restore" || snapshot.isPreviewable) {
          return snapshot;
        }
      }
    }
  }, {
    key: "getPreloadedSnapshot",
    value: function getPreloadedSnapshot() {
      if (this.snapshotHTML) {
        return PageSnapshot.fromHTMLString(this.snapshotHTML);
      }
    }
  }, {
    key: "hasCachedSnapshot",
    value: function hasCachedSnapshot() {
      return this.getCachedSnapshot() != null;
    }
  }, {
    key: "loadCachedSnapshot",
    value: function loadCachedSnapshot() {
      var _this19 = this;
      var snapshot = this.getCachedSnapshot();
      if (snapshot) {
        var isPreview = this.shouldIssueRequest();
        this.render(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                _this19.cacheSnapshot();
                if (!_this19.isSamePage) {
                  _context10.n = 1;
                  break;
                }
                _this19.adapter.visitRendered(_this19);
                _context10.n = 4;
                break;
              case 1:
                if (!_this19.view.renderPromise) {
                  _context10.n = 2;
                  break;
                }
                _context10.n = 2;
                return _this19.view.renderPromise;
              case 2:
                _context10.n = 3;
                return _this19.view.renderPage(snapshot, isPreview, _this19.willRender, _this19);
              case 3:
                _this19.performScroll();
                _this19.adapter.visitRendered(_this19);
                if (!isPreview) {
                  _this19.complete();
                }
              case 4:
                return _context10.a(2);
            }
          }, _callee10);
        })));
      }
    }
  }, {
    key: "followRedirect",
    value: function followRedirect() {
      var _a;
      if (this.redirectedToLocation && !this.followedRedirect && ((_a = this.response) === null || _a === void 0 ? void 0 : _a.redirected)) {
        this.adapter.visitProposedToLocation(this.redirectedToLocation, {
          action: "replace",
          response: this.response,
          shouldCacheSnapshot: false,
          willRender: false
        });
        this.followedRedirect = true;
      }
    }
  }, {
    key: "goToSamePageAnchor",
    value: function goToSamePageAnchor() {
      var _this20 = this;
      if (this.isSamePage) {
        this.render(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
          return _regenerator().w(function (_context11) {
            while (1) switch (_context11.n) {
              case 0:
                _this20.cacheSnapshot();
                _this20.performScroll();
                _this20.changeHistory();
                _this20.adapter.visitRendered(_this20);
              case 1:
                return _context11.a(2);
            }
          }, _callee11);
        })));
      }
    }
  }, {
    key: "prepareRequest",
    value: function prepareRequest(request) {
      if (this.acceptsStreamResponse) {
        request.acceptResponseType(StreamMessage.contentType);
      }
    }
  }, {
    key: "requestStarted",
    value: function requestStarted() {
      this.startRequest();
    }
  }, {
    key: "requestPreventedHandlingResponse",
    value: function requestPreventedHandlingResponse(_request, _response) {}
  }, {
    key: "requestSucceededWithResponse",
    value: function () {
      var _requestSucceededWithResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(request, response) {
        var responseHTML, redirected, statusCode;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return response.responseHTML;
            case 1:
              responseHTML = _context12.v;
              redirected = response.redirected, statusCode = response.statusCode;
              if (responseHTML == undefined) {
                this.recordResponse({
                  statusCode: SystemStatusCode.contentTypeMismatch,
                  redirected: redirected
                });
              } else {
                this.redirectedToLocation = response.redirected ? response.location : undefined;
                this.recordResponse({
                  statusCode: statusCode,
                  responseHTML: responseHTML,
                  redirected: redirected
                });
              }
            case 2:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function requestSucceededWithResponse(_x0, _x1) {
        return _requestSucceededWithResponse.apply(this, arguments);
      }
      return requestSucceededWithResponse;
    }()
  }, {
    key: "requestFailedWithResponse",
    value: function () {
      var _requestFailedWithResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(request, response) {
        var responseHTML, redirected, statusCode;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return response.responseHTML;
            case 1:
              responseHTML = _context13.v;
              redirected = response.redirected, statusCode = response.statusCode;
              if (responseHTML == undefined) {
                this.recordResponse({
                  statusCode: SystemStatusCode.contentTypeMismatch,
                  redirected: redirected
                });
              } else {
                this.recordResponse({
                  statusCode: statusCode,
                  responseHTML: responseHTML,
                  redirected: redirected
                });
              }
            case 2:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function requestFailedWithResponse(_x10, _x11) {
        return _requestFailedWithResponse.apply(this, arguments);
      }
      return requestFailedWithResponse;
    }()
  }, {
    key: "requestErrored",
    value: function requestErrored(_request, _error) {
      this.recordResponse({
        statusCode: SystemStatusCode.networkFailure,
        redirected: false
      });
    }
  }, {
    key: "requestFinished",
    value: function requestFinished() {
      this.finishRequest();
    }
  }, {
    key: "performScroll",
    value: function performScroll() {
      if (!this.scrolled && !this.view.forceReloaded) {
        if (this.action == "restore") {
          this.scrollToRestoredPosition() || this.scrollToAnchor() || this.view.scrollToTop();
        } else {
          this.scrollToAnchor() || this.view.scrollToTop();
        }
        if (this.isSamePage) {
          this.delegate.visitScrolledToSamePageLocation(this.view.lastRenderedLocation, this.location);
        }
        this.scrolled = true;
      }
    }
  }, {
    key: "scrollToRestoredPosition",
    value: function scrollToRestoredPosition() {
      var scrollPosition = this.restorationData.scrollPosition;
      if (scrollPosition) {
        this.view.scrollToPosition(scrollPosition);
        return true;
      }
    }
  }, {
    key: "scrollToAnchor",
    value: function scrollToAnchor() {
      var anchor = getAnchor(this.location);
      if (anchor != null) {
        this.view.scrollToAnchor(anchor);
        return true;
      }
    }
  }, {
    key: "recordTimingMetric",
    value: function recordTimingMetric(metric) {
      this.timingMetrics[metric] = new Date().getTime();
    }
  }, {
    key: "getTimingMetrics",
    value: function getTimingMetrics() {
      return Object.assign({}, this.timingMetrics);
    }
  }, {
    key: "getHistoryMethodForAction",
    value: function getHistoryMethodForAction(action) {
      switch (action) {
        case "replace":
          return history.replaceState;
        case "advance":
        case "restore":
          return history.pushState;
      }
    }
  }, {
    key: "hasPreloadedResponse",
    value: function hasPreloadedResponse() {
      return _typeof(this.response) == "object";
    }
  }, {
    key: "shouldIssueRequest",
    value: function shouldIssueRequest() {
      if (this.isSamePage) {
        return false;
      } else if (this.action == "restore") {
        return !this.hasCachedSnapshot();
      } else {
        return this.willRender;
      }
    }
  }, {
    key: "cacheSnapshot",
    value: function cacheSnapshot() {
      var _this21 = this;
      if (!this.snapshotCached) {
        this.view.cacheSnapshot(this.snapshot).then(function (snapshot) {
          return snapshot && _this21.visitCachedSnapshot(snapshot);
        });
        this.snapshotCached = true;
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(callback) {
        var _this22 = this;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              this.cancelRender();
              _context14.n = 1;
              return new Promise(function (resolve) {
                _this22.frame = requestAnimationFrame(function () {
                  return resolve();
                });
              });
            case 1:
              _context14.n = 2;
              return callback();
            case 2:
              delete this.frame;
            case 3:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function render(_x12) {
        return _render3.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "cancelRender",
    value: function cancelRender() {
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        delete this.frame;
      }
    }
  }]);
}();
function isSuccessful(statusCode) {
  return statusCode >= 200 && statusCode < 300;
}
var BrowserAdapter = /*#__PURE__*/function () {
  function BrowserAdapter(session) {
    var _this23 = this;
    _classCallCheck(this, BrowserAdapter);
    this.progressBar = new ProgressBar();
    this.showProgressBar = function () {
      _this23.progressBar.show();
    };
    this.session = session;
  }
  return _createClass(BrowserAdapter, [{
    key: "visitProposedToLocation",
    value: function visitProposedToLocation(location, options) {
      this.navigator.startVisit(location, (options === null || options === void 0 ? void 0 : options.restorationIdentifier) || uuid(), options);
    }
  }, {
    key: "visitStarted",
    value: function visitStarted(visit) {
      this.location = visit.location;
      visit.loadCachedSnapshot();
      visit.issueRequest();
      visit.goToSamePageAnchor();
    }
  }, {
    key: "visitRequestStarted",
    value: function visitRequestStarted(visit) {
      this.progressBar.setValue(0);
      if (visit.hasCachedSnapshot() || visit.action != "restore") {
        this.showVisitProgressBarAfterDelay();
      } else {
        this.showProgressBar();
      }
    }
  }, {
    key: "visitRequestCompleted",
    value: function visitRequestCompleted(visit) {
      visit.loadResponse();
    }
  }, {
    key: "visitRequestFailedWithStatusCode",
    value: function visitRequestFailedWithStatusCode(visit, statusCode) {
      switch (statusCode) {
        case SystemStatusCode.networkFailure:
        case SystemStatusCode.timeoutFailure:
        case SystemStatusCode.contentTypeMismatch:
          return this.reload({
            reason: "request_failed",
            context: {
              statusCode: statusCode
            }
          });
        default:
          return visit.loadResponse();
      }
    }
  }, {
    key: "visitRequestFinished",
    value: function visitRequestFinished(_visit) {
      this.progressBar.setValue(1);
      this.hideVisitProgressBar();
    }
  }, {
    key: "visitCompleted",
    value: function visitCompleted(_visit) {}
  }, {
    key: "pageInvalidated",
    value: function pageInvalidated(reason) {
      this.reload(reason);
    }
  }, {
    key: "visitFailed",
    value: function visitFailed(_visit) {}
  }, {
    key: "visitRendered",
    value: function visitRendered(_visit) {}
  }, {
    key: "formSubmissionStarted",
    value: function formSubmissionStarted(_formSubmission) {
      this.progressBar.setValue(0);
      this.showFormProgressBarAfterDelay();
    }
  }, {
    key: "formSubmissionFinished",
    value: function formSubmissionFinished(_formSubmission) {
      this.progressBar.setValue(1);
      this.hideFormProgressBar();
    }
  }, {
    key: "showVisitProgressBarAfterDelay",
    value: function showVisitProgressBarAfterDelay() {
      this.visitProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
  }, {
    key: "hideVisitProgressBar",
    value: function hideVisitProgressBar() {
      this.progressBar.hide();
      if (this.visitProgressBarTimeout != null) {
        window.clearTimeout(this.visitProgressBarTimeout);
        delete this.visitProgressBarTimeout;
      }
    }
  }, {
    key: "showFormProgressBarAfterDelay",
    value: function showFormProgressBarAfterDelay() {
      if (this.formProgressBarTimeout == null) {
        this.formProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
      }
    }
  }, {
    key: "hideFormProgressBar",
    value: function hideFormProgressBar() {
      this.progressBar.hide();
      if (this.formProgressBarTimeout != null) {
        window.clearTimeout(this.formProgressBarTimeout);
        delete this.formProgressBarTimeout;
      }
    }
  }, {
    key: "reload",
    value: function reload(reason) {
      var _a;
      dispatch("turbo:reload", {
        detail: reason
      });
      window.location.href = ((_a = this.location) === null || _a === void 0 ? void 0 : _a.toString()) || window.location.href;
    }
  }, {
    key: "navigator",
    get: function get() {
      return this.session.navigator;
    }
  }]);
}();
var CacheObserver = /*#__PURE__*/function () {
  function CacheObserver() {
    var _this24 = this;
    _classCallCheck(this, CacheObserver);
    this.selector = "[data-turbo-temporary]";
    this.deprecatedSelector = "[data-turbo-cache=false]";
    this.started = false;
    this.removeTemporaryElements = function (_event) {
      var _iterator14 = _createForOfIteratorHelper(_this24.temporaryElements),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var element = _step14.value;
          element.remove();
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    };
  }
  return _createClass(CacheObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.started = true;
        addEventListener("turbo:before-cache", this.removeTemporaryElements, false);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.started = false;
        removeEventListener("turbo:before-cache", this.removeTemporaryElements, false);
      }
    }
  }, {
    key: "temporaryElements",
    get: function get() {
      return [].concat(_toConsumableArray(document.querySelectorAll(this.selector)), _toConsumableArray(this.temporaryElementsWithDeprecation));
    }
  }, {
    key: "temporaryElementsWithDeprecation",
    get: function get() {
      var elements = document.querySelectorAll(this.deprecatedSelector);
      if (elements.length) {
        console.warn("The ".concat(this.deprecatedSelector, " selector is deprecated and will be removed in a future version. Use ").concat(this.selector, " instead."));
      }
      return _toConsumableArray(elements);
    }
  }]);
}();
var FrameRedirector = /*#__PURE__*/function () {
  function FrameRedirector(session, element) {
    _classCallCheck(this, FrameRedirector);
    this.session = session;
    this.element = element;
    this.linkInterceptor = new LinkInterceptor(this, element);
    this.formSubmitObserver = new FormSubmitObserver(this, element);
  }
  return _createClass(FrameRedirector, [{
    key: "start",
    value: function start() {
      this.linkInterceptor.start();
      this.formSubmitObserver.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.linkInterceptor.stop();
      this.formSubmitObserver.stop();
    }
  }, {
    key: "shouldInterceptLinkClick",
    value: function shouldInterceptLinkClick(element, _location, _event) {
      return this.shouldRedirect(element);
    }
  }, {
    key: "linkClickIntercepted",
    value: function linkClickIntercepted(element, url, event) {
      var frame = this.findFrameElement(element);
      if (frame) {
        frame.delegate.linkClickIntercepted(element, url, event);
      }
    }
  }, {
    key: "willSubmitForm",
    value: function willSubmitForm(element, submitter) {
      return element.closest("turbo-frame") == null && this.shouldSubmit(element, submitter) && this.shouldRedirect(element, submitter);
    }
  }, {
    key: "formSubmitted",
    value: function formSubmitted(element, submitter) {
      var frame = this.findFrameElement(element, submitter);
      if (frame) {
        frame.delegate.formSubmitted(element, submitter);
      }
    }
  }, {
    key: "shouldSubmit",
    value: function shouldSubmit(form, submitter) {
      var _a;
      var action = getAction(form, submitter);
      var meta = this.element.ownerDocument.querySelector("meta[name=\"turbo-root\"]");
      var rootLocation = expandURL((_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/");
      return this.shouldRedirect(form, submitter) && locationIsVisitable(action, rootLocation);
    }
  }, {
    key: "shouldRedirect",
    value: function shouldRedirect(element, submitter) {
      var isNavigatable = element instanceof HTMLFormElement ? this.session.submissionIsNavigatable(element, submitter) : this.session.elementIsNavigatable(element);
      if (isNavigatable) {
        var frame = this.findFrameElement(element, submitter);
        return frame ? frame != element.closest("turbo-frame") : false;
      } else {
        return false;
      }
    }
  }, {
    key: "findFrameElement",
    value: function findFrameElement(element, submitter) {
      var id = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("data-turbo-frame")) || element.getAttribute("data-turbo-frame");
      if (id && id != "_top") {
        var frame = this.element.querySelector("#".concat(id, ":not([disabled])"));
        if (frame instanceof FrameElement) {
          return frame;
        }
      }
    }
  }]);
}();
var History = /*#__PURE__*/function () {
  function History(delegate) {
    var _this25 = this;
    _classCallCheck(this, History);
    this.restorationIdentifier = uuid();
    this.restorationData = {};
    this.started = false;
    this.pageLoaded = false;
    this.onPopState = function (event) {
      if (_this25.shouldHandlePopState()) {
        var _ref16 = event.state || {},
          turbo = _ref16.turbo;
        if (turbo) {
          _this25.location = new URL(window.location.href);
          var restorationIdentifier = turbo.restorationIdentifier;
          _this25.restorationIdentifier = restorationIdentifier;
          _this25.delegate.historyPoppedToLocationWithRestorationIdentifier(_this25.location, restorationIdentifier);
        }
      }
    };
    this.onPageLoad = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(_event) {
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return nextMicrotask();
            case 1:
              _this25.pageLoaded = true;
            case 2:
              return _context15.a(2);
          }
        }, _callee15);
      }));
      return function (_x13) {
        return _ref17.apply(this, arguments);
      };
    }();
    this.delegate = delegate;
  }
  return _createClass(History, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        addEventListener("popstate", this.onPopState, false);
        addEventListener("load", this.onPageLoad, false);
        this.started = true;
        this.replace(new URL(window.location.href));
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        removeEventListener("popstate", this.onPopState, false);
        removeEventListener("load", this.onPageLoad, false);
        this.started = false;
      }
    }
  }, {
    key: "push",
    value: function push(location, restorationIdentifier) {
      this.update(history.pushState, location, restorationIdentifier);
    }
  }, {
    key: "replace",
    value: function replace(location, restorationIdentifier) {
      this.update(history.replaceState, location, restorationIdentifier);
    }
  }, {
    key: "update",
    value: function update(method, location) {
      var restorationIdentifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : uuid();
      var state = {
        turbo: {
          restorationIdentifier: restorationIdentifier
        }
      };
      method.call(history, state, "", location.href);
      this.location = location;
      this.restorationIdentifier = restorationIdentifier;
    }
  }, {
    key: "getRestorationDataForIdentifier",
    value: function getRestorationDataForIdentifier(restorationIdentifier) {
      return this.restorationData[restorationIdentifier] || {};
    }
  }, {
    key: "updateRestorationData",
    value: function updateRestorationData(additionalData) {
      var restorationIdentifier = this.restorationIdentifier;
      var restorationData = this.restorationData[restorationIdentifier];
      this.restorationData[restorationIdentifier] = Object.assign(Object.assign({}, restorationData), additionalData);
    }
  }, {
    key: "assumeControlOfScrollRestoration",
    value: function assumeControlOfScrollRestoration() {
      var _a;
      if (!this.previousScrollRestoration) {
        this.previousScrollRestoration = (_a = history.scrollRestoration) !== null && _a !== void 0 ? _a : "auto";
        history.scrollRestoration = "manual";
      }
    }
  }, {
    key: "relinquishControlOfScrollRestoration",
    value: function relinquishControlOfScrollRestoration() {
      if (this.previousScrollRestoration) {
        history.scrollRestoration = this.previousScrollRestoration;
        delete this.previousScrollRestoration;
      }
    }
  }, {
    key: "shouldHandlePopState",
    value: function shouldHandlePopState() {
      return this.pageIsLoaded();
    }
  }, {
    key: "pageIsLoaded",
    value: function pageIsLoaded() {
      return this.pageLoaded || document.readyState == "complete";
    }
  }]);
}();
var Navigator = /*#__PURE__*/function () {
  function Navigator(delegate) {
    _classCallCheck(this, Navigator);
    this.delegate = delegate;
  }
  return _createClass(Navigator, [{
    key: "proposeVisit",
    value: function proposeVisit(location) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.delegate.allowsVisitingLocationWithAction(location, options.action)) {
        if (locationIsVisitable(location, this.view.snapshot.rootLocation)) {
          this.delegate.visitProposedToLocation(location, options);
        } else {
          window.location.href = location.toString();
        }
      }
    }
  }, {
    key: "startVisit",
    value: function startVisit(locatable, restorationIdentifier) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.stop();
      this.currentVisit = new Visit(this, expandURL(locatable), restorationIdentifier, Object.assign({
        referrer: this.location
      }, options));
      this.currentVisit.start();
    }
  }, {
    key: "submitForm",
    value: function submitForm(form, submitter) {
      this.stop();
      this.formSubmission = new FormSubmission(this, form, submitter, true);
      this.formSubmission.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.formSubmission) {
        this.formSubmission.stop();
        delete this.formSubmission;
      }
      if (this.currentVisit) {
        this.currentVisit.cancel();
        delete this.currentVisit;
      }
    }
  }, {
    key: "adapter",
    get: function get() {
      return this.delegate.adapter;
    }
  }, {
    key: "view",
    get: function get() {
      return this.delegate.view;
    }
  }, {
    key: "history",
    get: function get() {
      return this.delegate.history;
    }
  }, {
    key: "formSubmissionStarted",
    value: function formSubmissionStarted(formSubmission) {
      if (typeof this.adapter.formSubmissionStarted === "function") {
        this.adapter.formSubmissionStarted(formSubmission);
      }
    }
  }, {
    key: "formSubmissionSucceededWithResponse",
    value: function () {
      var _formSubmissionSucceededWithResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(formSubmission, fetchResponse) {
        var responseHTML, shouldCacheSnapshot, statusCode, redirected, action, visitOptions;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              if (!(formSubmission == this.formSubmission)) {
                _context16.n = 2;
                break;
              }
              _context16.n = 1;
              return fetchResponse.responseHTML;
            case 1:
              responseHTML = _context16.v;
              if (responseHTML) {
                shouldCacheSnapshot = formSubmission.isSafe;
                if (!shouldCacheSnapshot) {
                  this.view.clearSnapshotCache();
                }
                statusCode = fetchResponse.statusCode, redirected = fetchResponse.redirected;
                action = this.getActionForFormSubmission(formSubmission);
                visitOptions = {
                  action: action,
                  shouldCacheSnapshot: shouldCacheSnapshot,
                  response: {
                    statusCode: statusCode,
                    responseHTML: responseHTML,
                    redirected: redirected
                  }
                };
                this.proposeVisit(fetchResponse.location, visitOptions);
              }
            case 2:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function formSubmissionSucceededWithResponse(_x14, _x15) {
        return _formSubmissionSucceededWithResponse.apply(this, arguments);
      }
      return formSubmissionSucceededWithResponse;
    }()
  }, {
    key: "formSubmissionFailedWithResponse",
    value: function () {
      var _formSubmissionFailedWithResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(formSubmission, fetchResponse) {
        var responseHTML, snapshot;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _context17.n = 1;
              return fetchResponse.responseHTML;
            case 1:
              responseHTML = _context17.v;
              if (!responseHTML) {
                _context17.n = 5;
                break;
              }
              snapshot = PageSnapshot.fromHTMLString(responseHTML);
              if (!fetchResponse.serverError) {
                _context17.n = 3;
                break;
              }
              _context17.n = 2;
              return this.view.renderError(snapshot, this.currentVisit);
            case 2:
              _context17.n = 4;
              break;
            case 3:
              _context17.n = 4;
              return this.view.renderPage(snapshot, false, true, this.currentVisit);
            case 4:
              this.view.scrollToTop();
              this.view.clearSnapshotCache();
            case 5:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
      function formSubmissionFailedWithResponse(_x16, _x17) {
        return _formSubmissionFailedWithResponse.apply(this, arguments);
      }
      return formSubmissionFailedWithResponse;
    }()
  }, {
    key: "formSubmissionErrored",
    value: function formSubmissionErrored(formSubmission, error) {
      console.error(error);
    }
  }, {
    key: "formSubmissionFinished",
    value: function formSubmissionFinished(formSubmission) {
      if (typeof this.adapter.formSubmissionFinished === "function") {
        this.adapter.formSubmissionFinished(formSubmission);
      }
    }
  }, {
    key: "visitStarted",
    value: function visitStarted(visit) {
      this.delegate.visitStarted(visit);
    }
  }, {
    key: "visitCompleted",
    value: function visitCompleted(visit) {
      this.delegate.visitCompleted(visit);
    }
  }, {
    key: "locationWithActionIsSamePage",
    value: function locationWithActionIsSamePage(location, action) {
      var anchor = getAnchor(location);
      var currentAnchor = getAnchor(this.view.lastRenderedLocation);
      var isRestorationToTop = action === "restore" && typeof anchor === "undefined";
      return action !== "replace" && getRequestURL(location) === getRequestURL(this.view.lastRenderedLocation) && (isRestorationToTop || anchor != null && anchor !== currentAnchor);
    }
  }, {
    key: "visitScrolledToSamePageLocation",
    value: function visitScrolledToSamePageLocation(oldURL, newURL) {
      this.delegate.visitScrolledToSamePageLocation(oldURL, newURL);
    }
  }, {
    key: "location",
    get: function get() {
      return this.history.location;
    }
  }, {
    key: "restorationIdentifier",
    get: function get() {
      return this.history.restorationIdentifier;
    }
  }, {
    key: "getActionForFormSubmission",
    value: function getActionForFormSubmission(_ref18) {
      var submitter = _ref18.submitter,
        formElement = _ref18.formElement;
      return getVisitAction(submitter, formElement) || "advance";
    }
  }]);
}();
var PageStage;
(function (PageStage) {
  PageStage[PageStage["initial"] = 0] = "initial";
  PageStage[PageStage["loading"] = 1] = "loading";
  PageStage[PageStage["interactive"] = 2] = "interactive";
  PageStage[PageStage["complete"] = 3] = "complete";
})(PageStage || (PageStage = {}));
var PageObserver = /*#__PURE__*/function () {
  function PageObserver(delegate) {
    var _this26 = this;
    _classCallCheck(this, PageObserver);
    this.stage = PageStage.initial;
    this.started = false;
    this.interpretReadyState = function () {
      var readyState = _this26.readyState;
      if (readyState == "interactive") {
        _this26.pageIsInteractive();
      } else if (readyState == "complete") {
        _this26.pageIsComplete();
      }
    };
    this.pageWillUnload = function () {
      _this26.delegate.pageWillUnload();
    };
    this.delegate = delegate;
  }
  return _createClass(PageObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        if (this.stage == PageStage.initial) {
          this.stage = PageStage.loading;
        }
        document.addEventListener("readystatechange", this.interpretReadyState, false);
        addEventListener("pagehide", this.pageWillUnload, false);
        this.started = true;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        document.removeEventListener("readystatechange", this.interpretReadyState, false);
        removeEventListener("pagehide", this.pageWillUnload, false);
        this.started = false;
      }
    }
  }, {
    key: "pageIsInteractive",
    value: function pageIsInteractive() {
      if (this.stage == PageStage.loading) {
        this.stage = PageStage.interactive;
        this.delegate.pageBecameInteractive();
      }
    }
  }, {
    key: "pageIsComplete",
    value: function pageIsComplete() {
      this.pageIsInteractive();
      if (this.stage == PageStage.interactive) {
        this.stage = PageStage.complete;
        this.delegate.pageLoaded();
      }
    }
  }, {
    key: "readyState",
    get: function get() {
      return document.readyState;
    }
  }]);
}();
var ScrollObserver = /*#__PURE__*/function () {
  function ScrollObserver(delegate) {
    var _this27 = this;
    _classCallCheck(this, ScrollObserver);
    this.started = false;
    this.onScroll = function () {
      _this27.updatePosition({
        x: window.pageXOffset,
        y: window.pageYOffset
      });
    };
    this.delegate = delegate;
  }
  return _createClass(ScrollObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        addEventListener("scroll", this.onScroll, false);
        this.onScroll();
        this.started = true;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        removeEventListener("scroll", this.onScroll, false);
        this.started = false;
      }
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(position) {
      this.delegate.scrollPositionChanged(position);
    }
  }]);
}();
var StreamMessageRenderer = /*#__PURE__*/function () {
  function StreamMessageRenderer() {
    _classCallCheck(this, StreamMessageRenderer);
  }
  return _createClass(StreamMessageRenderer, [{
    key: "render",
    value: function render(_ref19) {
      var fragment = _ref19.fragment;
      Bardo.preservingPermanentElements(this, getPermanentElementMapForFragment(fragment), function () {
        return document.documentElement.appendChild(fragment);
      });
    }
  }, {
    key: "enteringBardo",
    value: function enteringBardo(currentPermanentElement, newPermanentElement) {
      newPermanentElement.replaceWith(currentPermanentElement.cloneNode(true));
    }
  }, {
    key: "leavingBardo",
    value: function leavingBardo() {}
  }]);
}();
function getPermanentElementMapForFragment(fragment) {
  var permanentElementsInDocument = queryPermanentElementsAll(document.documentElement);
  var permanentElementMap = {};
  var _iterator15 = _createForOfIteratorHelper(permanentElementsInDocument),
    _step15;
  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var permanentElementInDocument = _step15.value;
      var id = permanentElementInDocument.id;
      var _iterator16 = _createForOfIteratorHelper(fragment.querySelectorAll("turbo-stream")),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var streamElement = _step16.value;
          var elementInStream = _getPermanentElementById(streamElement.templateElement.content, id);
          if (elementInStream) {
            permanentElementMap[id] = [permanentElementInDocument, elementInStream];
          }
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }
  return permanentElementMap;
}
var StreamObserver = /*#__PURE__*/function () {
  function StreamObserver(delegate) {
    var _this28 = this;
    _classCallCheck(this, StreamObserver);
    this.sources = new Set();
    this.started = false;
    this.inspectFetchResponse = function (event) {
      var response = fetchResponseFromEvent(event);
      if (response && fetchResponseIsStream(response)) {
        event.preventDefault();
        _this28.receiveMessageResponse(response);
      }
    };
    this.receiveMessageEvent = function (event) {
      if (_this28.started && typeof event.data == "string") {
        _this28.receiveMessageHTML(event.data);
      }
    };
    this.delegate = delegate;
  }
  return _createClass(StreamObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.started = true;
        addEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.started = false;
        removeEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
      }
    }
  }, {
    key: "connectStreamSource",
    value: function connectStreamSource(source) {
      if (!this.streamSourceIsConnected(source)) {
        this.sources.add(source);
        source.addEventListener("message", this.receiveMessageEvent, false);
      }
    }
  }, {
    key: "disconnectStreamSource",
    value: function disconnectStreamSource(source) {
      if (this.streamSourceIsConnected(source)) {
        this.sources["delete"](source);
        source.removeEventListener("message", this.receiveMessageEvent, false);
      }
    }
  }, {
    key: "streamSourceIsConnected",
    value: function streamSourceIsConnected(source) {
      return this.sources.has(source);
    }
  }, {
    key: "receiveMessageResponse",
    value: function () {
      var _receiveMessageResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(response) {
        var html;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _context18.n = 1;
              return response.responseHTML;
            case 1:
              html = _context18.v;
              if (html) {
                this.receiveMessageHTML(html);
              }
            case 2:
              return _context18.a(2);
          }
        }, _callee18, this);
      }));
      function receiveMessageResponse(_x18) {
        return _receiveMessageResponse.apply(this, arguments);
      }
      return receiveMessageResponse;
    }()
  }, {
    key: "receiveMessageHTML",
    value: function receiveMessageHTML(html) {
      this.delegate.receivedMessageFromStream(StreamMessage.wrap(html));
    }
  }]);
}();
function fetchResponseFromEvent(event) {
  var _a;
  var fetchResponse = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.fetchResponse;
  if (fetchResponse instanceof FetchResponse) {
    return fetchResponse;
  }
}
function fetchResponseIsStream(response) {
  var _a;
  var contentType = (_a = response.contentType) !== null && _a !== void 0 ? _a : "";
  return contentType.startsWith(StreamMessage.contentType);
}
var ErrorRenderer = /*#__PURE__*/function (_Renderer2) {
  function ErrorRenderer() {
    _classCallCheck(this, ErrorRenderer);
    return _callSuper(this, ErrorRenderer, arguments);
  }
  _inherits(ErrorRenderer, _Renderer2);
  return _createClass(ErrorRenderer, [{
    key: "render",
    value: function () {
      var _render4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              this.replaceHeadAndBody();
              this.activateScriptElements();
            case 1:
              return _context19.a(2);
          }
        }, _callee19, this);
      }));
      function render() {
        return _render4.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "replaceHeadAndBody",
    value: function replaceHeadAndBody() {
      var _document = document,
        documentElement = _document.documentElement,
        head = _document.head;
      documentElement.replaceChild(this.newHead, head);
      this.renderElement(this.currentElement, this.newElement);
    }
  }, {
    key: "activateScriptElements",
    value: function activateScriptElements() {
      var _iterator17 = _createForOfIteratorHelper(this.scriptElements),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var replaceableElement = _step17.value;
          var parentNode = replaceableElement.parentNode;
          if (parentNode) {
            var element = activateScriptElement(replaceableElement);
            parentNode.replaceChild(element, replaceableElement);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }, {
    key: "newHead",
    get: function get() {
      return this.newSnapshot.headSnapshot.element;
    }
  }, {
    key: "scriptElements",
    get: function get() {
      return document.documentElement.querySelectorAll("script");
    }
  }], [{
    key: "renderElement",
    value: function renderElement(currentElement, newElement) {
      var _document2 = document,
        documentElement = _document2.documentElement,
        body = _document2.body;
      documentElement.replaceChild(newElement, body);
    }
  }]);
}(Renderer);
var PageRenderer = /*#__PURE__*/function (_Renderer3) {
  function PageRenderer() {
    _classCallCheck(this, PageRenderer);
    return _callSuper(this, PageRenderer, arguments);
  }
  _inherits(PageRenderer, _Renderer3);
  return _createClass(PageRenderer, [{
    key: "shouldRender",
    get: function get() {
      return this.newSnapshot.isVisitable && this.trackedElementsAreIdentical;
    }
  }, {
    key: "reloadReason",
    get: function get() {
      if (!this.newSnapshot.isVisitable) {
        return {
          reason: "turbo_visit_control_is_reload"
        };
      }
      if (!this.trackedElementsAreIdentical) {
        return {
          reason: "tracked_element_mismatch"
        };
      }
    }
  }, {
    key: "prepareToRender",
    value: function () {
      var _prepareToRender = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              _context20.n = 1;
              return this.mergeHead();
            case 1:
              return _context20.a(2);
          }
        }, _callee20, this);
      }));
      function prepareToRender() {
        return _prepareToRender.apply(this, arguments);
      }
      return prepareToRender;
    }()
  }, {
    key: "render",
    value: function () {
      var _render5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              if (!this.willRender) {
                _context21.n = 1;
                break;
              }
              _context21.n = 1;
              return this.replaceBody();
            case 1:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function render() {
        return _render5.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "finishRendering",
    value: function finishRendering() {
      _superPropGet(PageRenderer, "finishRendering", this, 3)([]);
      if (!this.isPreview) {
        this.focusFirstAutofocusableElement();
      }
    }
  }, {
    key: "currentHeadSnapshot",
    get: function get() {
      return this.currentSnapshot.headSnapshot;
    }
  }, {
    key: "newHeadSnapshot",
    get: function get() {
      return this.newSnapshot.headSnapshot;
    }
  }, {
    key: "newElement",
    get: function get() {
      return this.newSnapshot.element;
    }
  }, {
    key: "mergeHead",
    value: function () {
      var _mergeHead = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
        var mergedHeadElements, newStylesheetElements;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              mergedHeadElements = this.mergeProvisionalElements();
              newStylesheetElements = this.copyNewHeadStylesheetElements();
              this.copyNewHeadScriptElements();
              _context22.n = 1;
              return mergedHeadElements;
            case 1:
              _context22.n = 2;
              return newStylesheetElements;
            case 2:
              return _context22.a(2);
          }
        }, _callee22, this);
      }));
      function mergeHead() {
        return _mergeHead.apply(this, arguments);
      }
      return mergeHead;
    }()
  }, {
    key: "replaceBody",
    value: function () {
      var _replaceBody = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
        var _this29 = this;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              _context24.n = 1;
              return this.preservingPermanentElements(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
                return _regenerator().w(function (_context23) {
                  while (1) switch (_context23.n) {
                    case 0:
                      _this29.activateNewBody();
                      _context23.n = 1;
                      return _this29.assignNewBody();
                    case 1:
                      return _context23.a(2);
                  }
                }, _callee23);
              })));
            case 1:
              return _context24.a(2);
          }
        }, _callee24, this);
      }));
      function replaceBody() {
        return _replaceBody.apply(this, arguments);
      }
      return replaceBody;
    }()
  }, {
    key: "trackedElementsAreIdentical",
    get: function get() {
      return this.currentHeadSnapshot.trackedElementSignature == this.newHeadSnapshot.trackedElementSignature;
    }
  }, {
    key: "copyNewHeadStylesheetElements",
    value: function () {
      var _copyNewHeadStylesheetElements = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
        var loadingElements, _iterator18, _step18, element;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              loadingElements = [];
              _iterator18 = _createForOfIteratorHelper(this.newHeadStylesheetElements);
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  element = _step18.value;
                  loadingElements.push(waitForLoad(element));
                  document.head.appendChild(element);
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
              _context25.n = 1;
              return Promise.all(loadingElements);
            case 1:
              return _context25.a(2);
          }
        }, _callee25, this);
      }));
      function copyNewHeadStylesheetElements() {
        return _copyNewHeadStylesheetElements.apply(this, arguments);
      }
      return copyNewHeadStylesheetElements;
    }()
  }, {
    key: "copyNewHeadScriptElements",
    value: function copyNewHeadScriptElements() {
      var _iterator19 = _createForOfIteratorHelper(this.newHeadScriptElements),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var element = _step19.value;
          document.head.appendChild(activateScriptElement(element));
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }
  }, {
    key: "mergeProvisionalElements",
    value: function () {
      var _mergeProvisionalElements = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26() {
        var newHeadElements, _iterator20, _step20, element, _iterator21, _step21, _element2;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.n) {
            case 0:
              newHeadElements = _toConsumableArray(this.newHeadProvisionalElements);
              _iterator20 = _createForOfIteratorHelper(this.currentHeadProvisionalElements);
              try {
                for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                  element = _step20.value;
                  if (!this.isCurrentElementInElementList(element, newHeadElements)) {
                    document.head.removeChild(element);
                  }
                }
              } catch (err) {
                _iterator20.e(err);
              } finally {
                _iterator20.f();
              }
              _iterator21 = _createForOfIteratorHelper(newHeadElements);
              try {
                for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                  _element2 = _step21.value;
                  document.head.appendChild(_element2);
                }
              } catch (err) {
                _iterator21.e(err);
              } finally {
                _iterator21.f();
              }
            case 1:
              return _context26.a(2);
          }
        }, _callee26, this);
      }));
      function mergeProvisionalElements() {
        return _mergeProvisionalElements.apply(this, arguments);
      }
      return mergeProvisionalElements;
    }()
  }, {
    key: "isCurrentElementInElementList",
    value: function isCurrentElementInElementList(element, elementList) {
      var _iterator22 = _createForOfIteratorHelper(elementList.entries()),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _ref21 = _step22.value;
          var _ref22 = _slicedToArray(_ref21, 2);
          var index = _ref22[0];
          var newElement = _ref22[1];
          if (element.tagName == "TITLE") {
            if (newElement.tagName != "TITLE") {
              continue;
            }
            if (element.innerHTML == newElement.innerHTML) {
              elementList.splice(index, 1);
              return true;
            }
          }
          if (newElement.isEqualNode(element)) {
            elementList.splice(index, 1);
            return true;
          }
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      return false;
    }
  }, {
    key: "removeCurrentHeadProvisionalElements",
    value: function removeCurrentHeadProvisionalElements() {
      var _iterator23 = _createForOfIteratorHelper(this.currentHeadProvisionalElements),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var element = _step23.value;
          document.head.removeChild(element);
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }
  }, {
    key: "copyNewHeadProvisionalElements",
    value: function copyNewHeadProvisionalElements() {
      var _iterator24 = _createForOfIteratorHelper(this.newHeadProvisionalElements),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var element = _step24.value;
          document.head.appendChild(element);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }
  }, {
    key: "activateNewBody",
    value: function activateNewBody() {
      document.adoptNode(this.newElement);
      this.activateNewBodyScriptElements();
    }
  }, {
    key: "activateNewBodyScriptElements",
    value: function activateNewBodyScriptElements() {
      var _iterator25 = _createForOfIteratorHelper(this.newBodyScriptElements),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var inertScriptElement = _step25.value;
          var activatedScriptElement = activateScriptElement(inertScriptElement);
          inertScriptElement.replaceWith(activatedScriptElement);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }
  }, {
    key: "assignNewBody",
    value: function () {
      var _assignNewBody = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              _context27.n = 1;
              return this.renderElement(this.currentElement, this.newElement);
            case 1:
              return _context27.a(2);
          }
        }, _callee27, this);
      }));
      function assignNewBody() {
        return _assignNewBody.apply(this, arguments);
      }
      return assignNewBody;
    }()
  }, {
    key: "newHeadStylesheetElements",
    get: function get() {
      return this.newHeadSnapshot.getStylesheetElementsNotInSnapshot(this.currentHeadSnapshot);
    }
  }, {
    key: "newHeadScriptElements",
    get: function get() {
      return this.newHeadSnapshot.getScriptElementsNotInSnapshot(this.currentHeadSnapshot);
    }
  }, {
    key: "currentHeadProvisionalElements",
    get: function get() {
      return this.currentHeadSnapshot.provisionalElements;
    }
  }, {
    key: "newHeadProvisionalElements",
    get: function get() {
      return this.newHeadSnapshot.provisionalElements;
    }
  }, {
    key: "newBodyScriptElements",
    get: function get() {
      return this.newElement.querySelectorAll("script");
    }
  }], [{
    key: "renderElement",
    value: function renderElement(currentElement, newElement) {
      if (document.body && newElement instanceof HTMLBodyElement) {
        document.body.replaceWith(newElement);
      } else {
        document.documentElement.appendChild(newElement);
      }
    }
  }]);
}(Renderer);
var SnapshotCache = /*#__PURE__*/function () {
  function SnapshotCache(size) {
    _classCallCheck(this, SnapshotCache);
    this.keys = [];
    this.snapshots = {};
    this.size = size;
  }
  return _createClass(SnapshotCache, [{
    key: "has",
    value: function has(location) {
      return toCacheKey(location) in this.snapshots;
    }
  }, {
    key: "get",
    value: function get(location) {
      if (this.has(location)) {
        var snapshot = this.read(location);
        this.touch(location);
        return snapshot;
      }
    }
  }, {
    key: "put",
    value: function put(location, snapshot) {
      this.write(location, snapshot);
      this.touch(location);
      return snapshot;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.snapshots = {};
    }
  }, {
    key: "read",
    value: function read(location) {
      return this.snapshots[toCacheKey(location)];
    }
  }, {
    key: "write",
    value: function write(location, snapshot) {
      this.snapshots[toCacheKey(location)] = snapshot;
    }
  }, {
    key: "touch",
    value: function touch(location) {
      var key = toCacheKey(location);
      var index = this.keys.indexOf(key);
      if (index > -1) this.keys.splice(index, 1);
      this.keys.unshift(key);
      this.trim();
    }
  }, {
    key: "trim",
    value: function trim() {
      var _iterator26 = _createForOfIteratorHelper(this.keys.splice(this.size)),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var key = _step26.value;
          delete this.snapshots[key];
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }
  }]);
}();
var PageView = /*#__PURE__*/function (_View2) {
  function PageView() {
    var _this30;
    _classCallCheck(this, PageView);
    _this30 = _callSuper(this, PageView, arguments);
    _this30.snapshotCache = new SnapshotCache(10);
    _this30.lastRenderedLocation = new URL(location.href);
    _this30.forceReloaded = false;
    return _this30;
  }
  _inherits(PageView, _View2);
  return _createClass(PageView, [{
    key: "renderPage",
    value: function renderPage(snapshot) {
      var isPreview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var willRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var visit = arguments.length > 3 ? arguments[3] : undefined;
      var renderer = new PageRenderer(this.snapshot, snapshot, PageRenderer.renderElement, isPreview, willRender);
      if (!renderer.shouldRender) {
        this.forceReloaded = true;
      } else {
        visit === null || visit === void 0 ? void 0 : visit.changeHistory();
      }
      return this.render(renderer);
    }
  }, {
    key: "renderError",
    value: function renderError(snapshot, visit) {
      visit === null || visit === void 0 ? void 0 : visit.changeHistory();
      var renderer = new ErrorRenderer(this.snapshot, snapshot, ErrorRenderer.renderElement, false);
      return this.render(renderer);
    }
  }, {
    key: "clearSnapshotCache",
    value: function clearSnapshotCache() {
      this.snapshotCache.clear();
    }
  }, {
    key: "cacheSnapshot",
    value: function () {
      var _cacheSnapshot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28() {
        var snapshot,
          _location3,
          cachedSnapshot,
          _args28 = arguments;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.n) {
            case 0:
              snapshot = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : this.snapshot;
              if (!snapshot.isCacheable) {
                _context28.n = 2;
                break;
              }
              this.delegate.viewWillCacheSnapshot();
              _location3 = this.lastRenderedLocation;
              _context28.n = 1;
              return nextEventLoopTick();
            case 1:
              cachedSnapshot = snapshot.clone();
              this.snapshotCache.put(_location3, cachedSnapshot);
              return _context28.a(2, cachedSnapshot);
            case 2:
              return _context28.a(2);
          }
        }, _callee28, this);
      }));
      function cacheSnapshot() {
        return _cacheSnapshot.apply(this, arguments);
      }
      return cacheSnapshot;
    }()
  }, {
    key: "getCachedSnapshotForLocation",
    value: function getCachedSnapshotForLocation(location) {
      return this.snapshotCache.get(location);
    }
  }, {
    key: "snapshot",
    get: function get() {
      return PageSnapshot.fromElement(this.element);
    }
  }]);
}(View);
var Preloader = /*#__PURE__*/function () {
  function Preloader(delegate) {
    _classCallCheck(this, Preloader);
    this.selector = "a[data-turbo-preload]";
    this.delegate = delegate;
  }
  return _createClass(Preloader, [{
    key: "snapshotCache",
    get: function get() {
      return this.delegate.navigator.view.snapshotCache;
    }
  }, {
    key: "start",
    value: function start() {
      var _this31 = this;
      if (document.readyState === "loading") {
        return document.addEventListener("DOMContentLoaded", function () {
          _this31.preloadOnLoadLinksForView(document.body);
        });
      } else {
        this.preloadOnLoadLinksForView(document.body);
      }
    }
  }, {
    key: "preloadOnLoadLinksForView",
    value: function preloadOnLoadLinksForView(element) {
      var _iterator27 = _createForOfIteratorHelper(element.querySelectorAll(this.selector)),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var link = _step27.value;
          this.preloadURL(link);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    }
  }, {
    key: "preloadURL",
    value: function () {
      var _preloadURL = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(link) {
        var location, response, responseText, snapshot, _t2;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.p = _context29.n) {
            case 0:
              location = new URL(link.href);
              if (!this.snapshotCache.has(location)) {
                _context29.n = 1;
                break;
              }
              return _context29.a(2);
            case 1:
              _context29.p = 1;
              _context29.n = 2;
              return fetch(location.toString(), {
                headers: {
                  "VND.PREFETCH": "true",
                  Accept: "text/html"
                }
              });
            case 2:
              response = _context29.v;
              _context29.n = 3;
              return response.text();
            case 3:
              responseText = _context29.v;
              snapshot = PageSnapshot.fromHTMLString(responseText);
              this.snapshotCache.put(location, snapshot);
              _context29.n = 5;
              break;
            case 4:
              _context29.p = 4;
              _t2 = _context29.v;
            case 5:
              return _context29.a(2);
          }
        }, _callee29, this, [[1, 4]]);
      }));
      function preloadURL(_x19) {
        return _preloadURL.apply(this, arguments);
      }
      return preloadURL;
    }()
  }]);
}();
var Session = /*#__PURE__*/function () {
  function Session() {
    _classCallCheck(this, Session);
    this.navigator = new Navigator(this);
    this.history = new History(this);
    this.preloader = new Preloader(this);
    this.view = new PageView(this, document.documentElement);
    this.adapter = new BrowserAdapter(this);
    this.pageObserver = new PageObserver(this);
    this.cacheObserver = new CacheObserver();
    this.linkClickObserver = new LinkClickObserver(this, window);
    this.formSubmitObserver = new FormSubmitObserver(this, document);
    this.scrollObserver = new ScrollObserver(this);
    this.streamObserver = new StreamObserver(this);
    this.formLinkClickObserver = new FormLinkClickObserver(this, document.documentElement);
    this.frameRedirector = new FrameRedirector(this, document.documentElement);
    this.streamMessageRenderer = new StreamMessageRenderer();
    this.drive = true;
    this.enabled = true;
    this.progressBarDelay = 500;
    this.started = false;
    this.formMode = "on";
  }
  return _createClass(Session, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.pageObserver.start();
        this.cacheObserver.start();
        this.formLinkClickObserver.start();
        this.linkClickObserver.start();
        this.formSubmitObserver.start();
        this.scrollObserver.start();
        this.streamObserver.start();
        this.frameRedirector.start();
        this.history.start();
        this.preloader.start();
        this.started = true;
        this.enabled = true;
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      this.enabled = false;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.pageObserver.stop();
        this.cacheObserver.stop();
        this.formLinkClickObserver.stop();
        this.linkClickObserver.stop();
        this.formSubmitObserver.stop();
        this.scrollObserver.stop();
        this.streamObserver.stop();
        this.frameRedirector.stop();
        this.history.stop();
        this.started = false;
      }
    }
  }, {
    key: "registerAdapter",
    value: function registerAdapter(adapter) {
      this.adapter = adapter;
    }
  }, {
    key: "visit",
    value: function visit(location) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var frameElement = options.frame ? document.getElementById(options.frame) : null;
      if (frameElement instanceof FrameElement) {
        frameElement.src = location.toString();
        frameElement.loaded;
      } else {
        this.navigator.proposeVisit(expandURL(location), options);
      }
    }
  }, {
    key: "connectStreamSource",
    value: function connectStreamSource(source) {
      this.streamObserver.connectStreamSource(source);
    }
  }, {
    key: "disconnectStreamSource",
    value: function disconnectStreamSource(source) {
      this.streamObserver.disconnectStreamSource(source);
    }
  }, {
    key: "renderStreamMessage",
    value: function renderStreamMessage(message) {
      this.streamMessageRenderer.render(StreamMessage.wrap(message));
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.view.clearSnapshotCache();
    }
  }, {
    key: "setProgressBarDelay",
    value: function setProgressBarDelay(delay) {
      this.progressBarDelay = delay;
    }
  }, {
    key: "setFormMode",
    value: function setFormMode(mode) {
      this.formMode = mode;
    }
  }, {
    key: "location",
    get: function get() {
      return this.history.location;
    }
  }, {
    key: "restorationIdentifier",
    get: function get() {
      return this.history.restorationIdentifier;
    }
  }, {
    key: "historyPoppedToLocationWithRestorationIdentifier",
    value: function historyPoppedToLocationWithRestorationIdentifier(location, restorationIdentifier) {
      if (this.enabled) {
        this.navigator.startVisit(location, restorationIdentifier, {
          action: "restore",
          historyChanged: true
        });
      } else {
        this.adapter.pageInvalidated({
          reason: "turbo_disabled"
        });
      }
    }
  }, {
    key: "scrollPositionChanged",
    value: function scrollPositionChanged(position) {
      this.history.updateRestorationData({
        scrollPosition: position
      });
    }
  }, {
    key: "willSubmitFormLinkToLocation",
    value: function willSubmitFormLinkToLocation(link, location) {
      return this.elementIsNavigatable(link) && locationIsVisitable(location, this.snapshot.rootLocation);
    }
  }, {
    key: "submittedFormLinkToLocation",
    value: function submittedFormLinkToLocation() {}
  }, {
    key: "willFollowLinkToLocation",
    value: function willFollowLinkToLocation(link, location, event) {
      return this.elementIsNavigatable(link) && locationIsVisitable(location, this.snapshot.rootLocation) && this.applicationAllowsFollowingLinkToLocation(link, location, event);
    }
  }, {
    key: "followedLinkToLocation",
    value: function followedLinkToLocation(link, location) {
      var action = this.getActionForLink(link);
      var acceptsStreamResponse = link.hasAttribute("data-turbo-stream");
      this.visit(location.href, {
        action: action,
        acceptsStreamResponse: acceptsStreamResponse
      });
    }
  }, {
    key: "allowsVisitingLocationWithAction",
    value: function allowsVisitingLocationWithAction(location, action) {
      return this.locationWithActionIsSamePage(location, action) || this.applicationAllowsVisitingLocation(location);
    }
  }, {
    key: "visitProposedToLocation",
    value: function visitProposedToLocation(location, options) {
      extendURLWithDeprecatedProperties(location);
      this.adapter.visitProposedToLocation(location, options);
    }
  }, {
    key: "visitStarted",
    value: function visitStarted(visit) {
      if (!visit.acceptsStreamResponse) {
        markAsBusy(document.documentElement);
      }
      extendURLWithDeprecatedProperties(visit.location);
      if (!visit.silent) {
        this.notifyApplicationAfterVisitingLocation(visit.location, visit.action);
      }
    }
  }, {
    key: "visitCompleted",
    value: function visitCompleted(visit) {
      clearBusyState(document.documentElement);
      this.notifyApplicationAfterPageLoad(visit.getTimingMetrics());
    }
  }, {
    key: "locationWithActionIsSamePage",
    value: function locationWithActionIsSamePage(location, action) {
      return this.navigator.locationWithActionIsSamePage(location, action);
    }
  }, {
    key: "visitScrolledToSamePageLocation",
    value: function visitScrolledToSamePageLocation(oldURL, newURL) {
      this.notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL);
    }
  }, {
    key: "willSubmitForm",
    value: function willSubmitForm(form, submitter) {
      var action = getAction(form, submitter);
      return this.submissionIsNavigatable(form, submitter) && locationIsVisitable(expandURL(action), this.snapshot.rootLocation);
    }
  }, {
    key: "formSubmitted",
    value: function formSubmitted(form, submitter) {
      this.navigator.submitForm(form, submitter);
    }
  }, {
    key: "pageBecameInteractive",
    value: function pageBecameInteractive() {
      this.view.lastRenderedLocation = this.location;
      this.notifyApplicationAfterPageLoad();
    }
  }, {
    key: "pageLoaded",
    value: function pageLoaded() {
      this.history.assumeControlOfScrollRestoration();
    }
  }, {
    key: "pageWillUnload",
    value: function pageWillUnload() {
      this.history.relinquishControlOfScrollRestoration();
    }
  }, {
    key: "receivedMessageFromStream",
    value: function receivedMessageFromStream(message) {
      this.renderStreamMessage(message);
    }
  }, {
    key: "viewWillCacheSnapshot",
    value: function viewWillCacheSnapshot() {
      var _a;
      if (!((_a = this.navigator.currentVisit) === null || _a === void 0 ? void 0 : _a.silent)) {
        this.notifyApplicationBeforeCachingSnapshot();
      }
    }
  }, {
    key: "allowsImmediateRender",
    value: function allowsImmediateRender(_ref23, options) {
      var element = _ref23.element;
      var event = this.notifyApplicationBeforeRender(element, options);
      var defaultPrevented = event.defaultPrevented,
        render = event.detail.render;
      if (this.view.renderer && render) {
        this.view.renderer.renderElement = render;
      }
      return !defaultPrevented;
    }
  }, {
    key: "viewRenderedSnapshot",
    value: function viewRenderedSnapshot(_snapshot, _isPreview) {
      this.view.lastRenderedLocation = this.history.location;
      this.notifyApplicationAfterRender();
    }
  }, {
    key: "preloadOnLoadLinksForView",
    value: function preloadOnLoadLinksForView(element) {
      this.preloader.preloadOnLoadLinksForView(element);
    }
  }, {
    key: "viewInvalidated",
    value: function viewInvalidated(reason) {
      this.adapter.pageInvalidated(reason);
    }
  }, {
    key: "frameLoaded",
    value: function frameLoaded(frame) {
      this.notifyApplicationAfterFrameLoad(frame);
    }
  }, {
    key: "frameRendered",
    value: function frameRendered(fetchResponse, frame) {
      this.notifyApplicationAfterFrameRender(fetchResponse, frame);
    }
  }, {
    key: "applicationAllowsFollowingLinkToLocation",
    value: function applicationAllowsFollowingLinkToLocation(link, location, ev) {
      var event = this.notifyApplicationAfterClickingLinkToLocation(link, location, ev);
      return !event.defaultPrevented;
    }
  }, {
    key: "applicationAllowsVisitingLocation",
    value: function applicationAllowsVisitingLocation(location) {
      var event = this.notifyApplicationBeforeVisitingLocation(location);
      return !event.defaultPrevented;
    }
  }, {
    key: "notifyApplicationAfterClickingLinkToLocation",
    value: function notifyApplicationAfterClickingLinkToLocation(link, location, event) {
      return dispatch("turbo:click", {
        target: link,
        detail: {
          url: location.href,
          originalEvent: event
        },
        cancelable: true
      });
    }
  }, {
    key: "notifyApplicationBeforeVisitingLocation",
    value: function notifyApplicationBeforeVisitingLocation(location) {
      return dispatch("turbo:before-visit", {
        detail: {
          url: location.href
        },
        cancelable: true
      });
    }
  }, {
    key: "notifyApplicationAfterVisitingLocation",
    value: function notifyApplicationAfterVisitingLocation(location, action) {
      return dispatch("turbo:visit", {
        detail: {
          url: location.href,
          action: action
        }
      });
    }
  }, {
    key: "notifyApplicationBeforeCachingSnapshot",
    value: function notifyApplicationBeforeCachingSnapshot() {
      return dispatch("turbo:before-cache");
    }
  }, {
    key: "notifyApplicationBeforeRender",
    value: function notifyApplicationBeforeRender(newBody, options) {
      return dispatch("turbo:before-render", {
        detail: Object.assign({
          newBody: newBody
        }, options),
        cancelable: true
      });
    }
  }, {
    key: "notifyApplicationAfterRender",
    value: function notifyApplicationAfterRender() {
      return dispatch("turbo:render");
    }
  }, {
    key: "notifyApplicationAfterPageLoad",
    value: function notifyApplicationAfterPageLoad() {
      var timing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return dispatch("turbo:load", {
        detail: {
          url: this.location.href,
          timing: timing
        }
      });
    }
  }, {
    key: "notifyApplicationAfterVisitingSamePageLocation",
    value: function notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL) {
      dispatchEvent(new HashChangeEvent("hashchange", {
        oldURL: oldURL.toString(),
        newURL: newURL.toString()
      }));
    }
  }, {
    key: "notifyApplicationAfterFrameLoad",
    value: function notifyApplicationAfterFrameLoad(frame) {
      return dispatch("turbo:frame-load", {
        target: frame
      });
    }
  }, {
    key: "notifyApplicationAfterFrameRender",
    value: function notifyApplicationAfterFrameRender(fetchResponse, frame) {
      return dispatch("turbo:frame-render", {
        detail: {
          fetchResponse: fetchResponse
        },
        target: frame,
        cancelable: true
      });
    }
  }, {
    key: "submissionIsNavigatable",
    value: function submissionIsNavigatable(form, submitter) {
      if (this.formMode == "off") {
        return false;
      } else {
        var submitterIsNavigatable = submitter ? this.elementIsNavigatable(submitter) : true;
        if (this.formMode == "optin") {
          return submitterIsNavigatable && form.closest('[data-turbo="true"]') != null;
        } else {
          return submitterIsNavigatable && this.elementIsNavigatable(form);
        }
      }
    }
  }, {
    key: "elementIsNavigatable",
    value: function elementIsNavigatable(element) {
      var container = findClosestRecursively(element, "[data-turbo]");
      var withinFrame = findClosestRecursively(element, "turbo-frame");
      if (this.drive || withinFrame) {
        if (container) {
          return container.getAttribute("data-turbo") != "false";
        } else {
          return true;
        }
      } else {
        if (container) {
          return container.getAttribute("data-turbo") == "true";
        } else {
          return false;
        }
      }
    }
  }, {
    key: "getActionForLink",
    value: function getActionForLink(link) {
      return getVisitAction(link) || "advance";
    }
  }, {
    key: "snapshot",
    get: function get() {
      return this.view.snapshot;
    }
  }]);
}();
function extendURLWithDeprecatedProperties(url) {
  Object.defineProperties(url, deprecatedLocationPropertyDescriptors);
}
var deprecatedLocationPropertyDescriptors = {
  absoluteURL: {
    get: function get() {
      return this.toString();
    }
  }
};
var Cache = /*#__PURE__*/function () {
  function Cache(session) {
    _classCallCheck(this, Cache);
    this.session = session;
  }
  return _createClass(Cache, [{
    key: "clear",
    value: function clear() {
      this.session.clearCache();
    }
  }, {
    key: "resetCacheControl",
    value: function resetCacheControl() {
      this.setCacheControl("");
    }
  }, {
    key: "exemptPageFromCache",
    value: function exemptPageFromCache() {
      this.setCacheControl("no-cache");
    }
  }, {
    key: "exemptPageFromPreview",
    value: function exemptPageFromPreview() {
      this.setCacheControl("no-preview");
    }
  }, {
    key: "setCacheControl",
    value: function setCacheControl(value) {
      setMetaContent("turbo-cache-control", value);
    }
  }]);
}();
var StreamActions = {
  after: function after() {
    var _this32 = this;
    this.targetElements.forEach(function (e) {
      var _a;
      return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(_this32.templateContent, e.nextSibling);
    });
  },
  append: function append() {
    var _this33 = this;
    this.removeDuplicateTargetChildren();
    this.targetElements.forEach(function (e) {
      return e.append(_this33.templateContent);
    });
  },
  before: function before() {
    var _this34 = this;
    this.targetElements.forEach(function (e) {
      var _a;
      return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(_this34.templateContent, e);
    });
  },
  prepend: function prepend() {
    var _this35 = this;
    this.removeDuplicateTargetChildren();
    this.targetElements.forEach(function (e) {
      return e.prepend(_this35.templateContent);
    });
  },
  remove: function remove() {
    this.targetElements.forEach(function (e) {
      return e.remove();
    });
  },
  replace: function replace() {
    var _this36 = this;
    this.targetElements.forEach(function (e) {
      return e.replaceWith(_this36.templateContent);
    });
  },
  update: function update() {
    var _this37 = this;
    this.targetElements.forEach(function (targetElement) {
      targetElement.innerHTML = "";
      targetElement.append(_this37.templateContent);
    });
  }
};
var session = new Session();
var cache = new Cache(session);
var navigator$1 = session.navigator;
function start() {
  session.start();
}
function registerAdapter(adapter) {
  session.registerAdapter(adapter);
}
function visit(location, options) {
  session.visit(location, options);
}
function connectStreamSource(source) {
  session.connectStreamSource(source);
}
function disconnectStreamSource(source) {
  session.disconnectStreamSource(source);
}
function renderStreamMessage(message) {
  session.renderStreamMessage(message);
}
function clearCache() {
  console.warn("Please replace `Turbo.clearCache()` with `Turbo.cache.clear()`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
  session.clearCache();
}
function setProgressBarDelay(delay) {
  session.setProgressBarDelay(delay);
}
function setConfirmMethod(confirmMethod) {
  FormSubmission.confirmMethod = confirmMethod;
}
function setFormMode(mode) {
  session.setFormMode(mode);
}
var Turbo = /*#__PURE__*/Object.freeze({
  __proto__: null,
  navigator: navigator$1,
  session: session,
  cache: cache,
  PageRenderer: PageRenderer,
  PageSnapshot: PageSnapshot,
  FrameRenderer: FrameRenderer,
  start: start,
  registerAdapter: registerAdapter,
  visit: visit,
  connectStreamSource: connectStreamSource,
  disconnectStreamSource: disconnectStreamSource,
  renderStreamMessage: renderStreamMessage,
  clearCache: clearCache,
  setProgressBarDelay: setProgressBarDelay,
  setConfirmMethod: setConfirmMethod,
  setFormMode: setFormMode,
  StreamActions: StreamActions
});
var TurboFrameMissingError = /*#__PURE__*/function (_Error) {
  function TurboFrameMissingError() {
    _classCallCheck(this, TurboFrameMissingError);
    return _callSuper(this, TurboFrameMissingError, arguments);
  }
  _inherits(TurboFrameMissingError, _Error);
  return _createClass(TurboFrameMissingError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var FrameController = /*#__PURE__*/function () {
  function FrameController(element) {
    var _this38 = this;
    _classCallCheck(this, FrameController);
    this.fetchResponseLoaded = function (_fetchResponse) {};
    this.currentFetchRequest = null;
    this.resolveVisitPromise = function () {};
    this.connected = false;
    this.hasBeenLoaded = false;
    this.ignoredAttributes = new Set();
    this.action = null;
    this.visitCachedSnapshot = function (_ref13) {
      var element = _ref13.element;
      var frame = element.querySelector("#" + _this38.element.id);
      if (frame && _this38.previousFrameElement) {
        frame.replaceChildren.apply(frame, _toConsumableArray(_this38.previousFrameElement.children));
      }
      delete _this38.previousFrameElement;
    };
    this.element = element;
    this.view = new FrameView(this, this.element);
    this.appearanceObserver = new AppearanceObserver(this, this.element);
    this.formLinkClickObserver = new FormLinkClickObserver(this, this.element);
    this.linkInterceptor = new LinkInterceptor(this, this.element);
    this.restorationIdentifier = uuid();
    this.formSubmitObserver = new FormSubmitObserver(this, this.element);
  }
  return _createClass(FrameController, [{
    key: "connect",
    value: function connect() {
      if (!this.connected) {
        this.connected = true;
        if (this.loadingStyle == FrameLoadingStyle.lazy) {
          this.appearanceObserver.start();
        } else {
          this.loadSourceURL();
        }
        this.formLinkClickObserver.start();
        this.linkInterceptor.start();
        this.formSubmitObserver.start();
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.connected) {
        this.connected = false;
        this.appearanceObserver.stop();
        this.formLinkClickObserver.stop();
        this.linkInterceptor.stop();
        this.formSubmitObserver.stop();
      }
    }
  }, {
    key: "disabledChanged",
    value: function disabledChanged() {
      if (this.loadingStyle == FrameLoadingStyle.eager) {
        this.loadSourceURL();
      }
    }
  }, {
    key: "sourceURLChanged",
    value: function sourceURLChanged() {
      if (this.isIgnoringChangesTo("src")) return;
      if (this.element.isConnected) {
        this.complete = false;
      }
      if (this.loadingStyle == FrameLoadingStyle.eager || this.hasBeenLoaded) {
        this.loadSourceURL();
      }
    }
  }, {
    key: "sourceURLReloaded",
    value: function sourceURLReloaded() {
      var _this39 = this;
      var src = this.element.src;
      this.ignoringChangesToAttribute("complete", function () {
        _this39.element.removeAttribute("complete");
      });
      this.element.src = null;
      this.element.src = src;
      return this.element.loaded;
    }
  }, {
    key: "completeChanged",
    value: function completeChanged() {
      if (this.isIgnoringChangesTo("complete")) return;
      this.loadSourceURL();
    }
  }, {
    key: "loadingStyleChanged",
    value: function loadingStyleChanged() {
      if (this.loadingStyle == FrameLoadingStyle.lazy) {
        this.appearanceObserver.start();
      } else {
        this.appearanceObserver.stop();
        this.loadSourceURL();
      }
    }
  }, {
    key: "loadSourceURL",
    value: function () {
      var _loadSourceURL = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30() {
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              if (!(this.enabled && this.isActive && !this.complete && this.sourceURL)) {
                _context30.n = 2;
                break;
              }
              this.element.loaded = this.visit(expandURL(this.sourceURL));
              this.appearanceObserver.stop();
              _context30.n = 1;
              return this.element.loaded;
            case 1:
              this.hasBeenLoaded = true;
            case 2:
              return _context30.a(2);
          }
        }, _callee30, this);
      }));
      function loadSourceURL() {
        return _loadSourceURL.apply(this, arguments);
      }
      return loadSourceURL;
    }()
  }, {
    key: "loadResponse",
    value: function () {
      var _loadResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(fetchResponse) {
        var html, _document3, pageSnapshot;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.p = _context31.n) {
            case 0:
              if (fetchResponse.redirected || fetchResponse.succeeded && fetchResponse.isHTML) {
                this.sourceURL = fetchResponse.response.url;
              }
              _context31.p = 1;
              _context31.n = 2;
              return fetchResponse.responseHTML;
            case 2:
              html = _context31.v;
              if (!html) {
                _context31.n = 5;
                break;
              }
              _document3 = parseHTMLDocument(html);
              pageSnapshot = PageSnapshot.fromDocument(_document3);
              if (!pageSnapshot.isVisitable) {
                _context31.n = 4;
                break;
              }
              _context31.n = 3;
              return this.loadFrameResponse(fetchResponse, _document3);
            case 3:
              _context31.n = 5;
              break;
            case 4:
              _context31.n = 5;
              return this.handleUnvisitableFrameResponse(fetchResponse);
            case 5:
              _context31.p = 5;
              this.fetchResponseLoaded = function () {};
              return _context31.f(5);
            case 6:
              return _context31.a(2);
          }
        }, _callee31, this, [[1,, 5, 6]]);
      }));
      function loadResponse(_x20) {
        return _loadResponse.apply(this, arguments);
      }
      return loadResponse;
    }()
  }, {
    key: "elementAppearedInViewport",
    value: function elementAppearedInViewport(element) {
      this.proposeVisitIfNavigatedWithAction(element, element);
      this.loadSourceURL();
    }
  }, {
    key: "willSubmitFormLinkToLocation",
    value: function willSubmitFormLinkToLocation(link) {
      return this.shouldInterceptNavigation(link);
    }
  }, {
    key: "submittedFormLinkToLocation",
    value: function submittedFormLinkToLocation(link, _location, form) {
      var frame = this.findFrameElement(link);
      if (frame) form.setAttribute("data-turbo-frame", frame.id);
    }
  }, {
    key: "shouldInterceptLinkClick",
    value: function shouldInterceptLinkClick(element, _location, _event) {
      return this.shouldInterceptNavigation(element);
    }
  }, {
    key: "linkClickIntercepted",
    value: function linkClickIntercepted(element, location) {
      this.navigateFrame(element, location);
    }
  }, {
    key: "willSubmitForm",
    value: function willSubmitForm(element, submitter) {
      return element.closest("turbo-frame") == this.element && this.shouldInterceptNavigation(element, submitter);
    }
  }, {
    key: "formSubmitted",
    value: function formSubmitted(element, submitter) {
      if (this.formSubmission) {
        this.formSubmission.stop();
      }
      this.formSubmission = new FormSubmission(this, element, submitter);
      var fetchRequest = this.formSubmission.fetchRequest;
      this.prepareRequest(fetchRequest);
      this.formSubmission.start();
    }
  }, {
    key: "prepareRequest",
    value: function prepareRequest(request) {
      var _a;
      request.headers["Turbo-Frame"] = this.id;
      if ((_a = this.currentNavigationElement) === null || _a === void 0 ? void 0 : _a.hasAttribute("data-turbo-stream")) {
        request.acceptResponseType(StreamMessage.contentType);
      }
    }
  }, {
    key: "requestStarted",
    value: function requestStarted(_request) {
      markAsBusy(this.element);
    }
  }, {
    key: "requestPreventedHandlingResponse",
    value: function requestPreventedHandlingResponse(_request, _response) {
      this.resolveVisitPromise();
    }
  }, {
    key: "requestSucceededWithResponse",
    value: function () {
      var _requestSucceededWithResponse2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(request, response) {
        return _regenerator().w(function (_context32) {
          while (1) switch (_context32.n) {
            case 0:
              _context32.n = 1;
              return this.loadResponse(response);
            case 1:
              this.resolveVisitPromise();
            case 2:
              return _context32.a(2);
          }
        }, _callee32, this);
      }));
      function requestSucceededWithResponse(_x21, _x22) {
        return _requestSucceededWithResponse2.apply(this, arguments);
      }
      return requestSucceededWithResponse;
    }()
  }, {
    key: "requestFailedWithResponse",
    value: function () {
      var _requestFailedWithResponse2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(request, response) {
        return _regenerator().w(function (_context33) {
          while (1) switch (_context33.n) {
            case 0:
              _context33.n = 1;
              return this.loadResponse(response);
            case 1:
              this.resolveVisitPromise();
            case 2:
              return _context33.a(2);
          }
        }, _callee33, this);
      }));
      function requestFailedWithResponse(_x23, _x24) {
        return _requestFailedWithResponse2.apply(this, arguments);
      }
      return requestFailedWithResponse;
    }()
  }, {
    key: "requestErrored",
    value: function requestErrored(request, error) {
      console.error(error);
      this.resolveVisitPromise();
    }
  }, {
    key: "requestFinished",
    value: function requestFinished(_request) {
      clearBusyState(this.element);
    }
  }, {
    key: "formSubmissionStarted",
    value: function formSubmissionStarted(_ref14) {
      var formElement = _ref14.formElement;
      markAsBusy(formElement, this.findFrameElement(formElement));
    }
  }, {
    key: "formSubmissionSucceededWithResponse",
    value: function formSubmissionSucceededWithResponse(formSubmission, response) {
      var frame = this.findFrameElement(formSubmission.formElement, formSubmission.submitter);
      frame.delegate.proposeVisitIfNavigatedWithAction(frame, formSubmission.formElement, formSubmission.submitter);
      frame.delegate.loadResponse(response);
      if (!formSubmission.isSafe) {
        session.clearCache();
      }
    }
  }, {
    key: "formSubmissionFailedWithResponse",
    value: function formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
      this.element.delegate.loadResponse(fetchResponse);
      session.clearCache();
    }
  }, {
    key: "formSubmissionErrored",
    value: function formSubmissionErrored(formSubmission, error) {
      console.error(error);
    }
  }, {
    key: "formSubmissionFinished",
    value: function formSubmissionFinished(_ref15) {
      var formElement = _ref15.formElement;
      clearBusyState(formElement, this.findFrameElement(formElement));
    }
  }, {
    key: "allowsImmediateRender",
    value: function allowsImmediateRender(_ref20, options) {
      var newFrame = _ref20.element;
      var event = dispatch("turbo:before-frame-render", {
        target: this.element,
        detail: Object.assign({
          newFrame: newFrame
        }, options),
        cancelable: true
      });
      var defaultPrevented = event.defaultPrevented,
        render = event.detail.render;
      if (this.view.renderer && render) {
        this.view.renderer.renderElement = render;
      }
      return !defaultPrevented;
    }
  }, {
    key: "viewRenderedSnapshot",
    value: function viewRenderedSnapshot(_snapshot, _isPreview) {}
  }, {
    key: "preloadOnLoadLinksForView",
    value: function preloadOnLoadLinksForView(element) {
      session.preloadOnLoadLinksForView(element);
    }
  }, {
    key: "viewInvalidated",
    value: function viewInvalidated() {}
  }, {
    key: "willRenderFrame",
    value: function willRenderFrame(currentElement, _newElement) {
      this.previousFrameElement = currentElement.cloneNode(true);
    }
  }, {
    key: "loadFrameResponse",
    value: function () {
      var _loadFrameResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(fetchResponse, document) {
        var newFrameElement, snapshot, renderer;
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.n) {
            case 0:
              _context34.n = 1;
              return this.extractForeignFrameElement(document.body);
            case 1:
              newFrameElement = _context34.v;
              if (!newFrameElement) {
                _context34.n = 4;
                break;
              }
              snapshot = new Snapshot(newFrameElement);
              renderer = new FrameRenderer(this, this.view.snapshot, snapshot, FrameRenderer.renderElement, false, false);
              if (!this.view.renderPromise) {
                _context34.n = 2;
                break;
              }
              _context34.n = 2;
              return this.view.renderPromise;
            case 2:
              this.changeHistory();
              _context34.n = 3;
              return this.view.render(renderer);
            case 3:
              this.complete = true;
              session.frameRendered(fetchResponse, this.element);
              session.frameLoaded(this.element);
              this.fetchResponseLoaded(fetchResponse);
              _context34.n = 5;
              break;
            case 4:
              if (this.willHandleFrameMissingFromResponse(fetchResponse)) {
                this.handleFrameMissingFromResponse(fetchResponse);
              }
            case 5:
              return _context34.a(2);
          }
        }, _callee34, this);
      }));
      function loadFrameResponse(_x25, _x26) {
        return _loadFrameResponse.apply(this, arguments);
      }
      return loadFrameResponse;
    }()
  }, {
    key: "visit",
    value: function () {
      var _visit2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35(url) {
        var _this40 = this;
        var _a, request;
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.n) {
            case 0:
              request = new FetchRequest(this, FetchMethod.get, url, new URLSearchParams(), this.element);
              (_a = this.currentFetchRequest) === null || _a === void 0 ? void 0 : _a.cancel();
              this.currentFetchRequest = request;
              return _context35.a(2, new Promise(function (resolve) {
                _this40.resolveVisitPromise = function () {
                  _this40.resolveVisitPromise = function () {};
                  _this40.currentFetchRequest = null;
                  resolve();
                };
                request.perform();
              }));
          }
        }, _callee35, this);
      }));
      function visit(_x27) {
        return _visit2.apply(this, arguments);
      }
      return visit;
    }()
  }, {
    key: "navigateFrame",
    value: function navigateFrame(element, url, submitter) {
      var frame = this.findFrameElement(element, submitter);
      frame.delegate.proposeVisitIfNavigatedWithAction(frame, element, submitter);
      this.withCurrentNavigationElement(element, function () {
        frame.src = url;
      });
    }
  }, {
    key: "proposeVisitIfNavigatedWithAction",
    value: function proposeVisitIfNavigatedWithAction(frame, element, submitter) {
      var _this41 = this;
      this.action = getVisitAction(submitter, element, frame);
      if (this.action) {
        var pageSnapshot = PageSnapshot.fromElement(frame).clone();
        var visitCachedSnapshot = frame.delegate.visitCachedSnapshot;
        frame.delegate.fetchResponseLoaded = function (fetchResponse) {
          if (frame.src) {
            var statusCode = fetchResponse.statusCode,
              redirected = fetchResponse.redirected;
            var responseHTML = frame.ownerDocument.documentElement.outerHTML;
            var response = {
              statusCode: statusCode,
              redirected: redirected,
              responseHTML: responseHTML
            };
            var options = {
              response: response,
              visitCachedSnapshot: visitCachedSnapshot,
              willRender: false,
              updateHistory: false,
              restorationIdentifier: _this41.restorationIdentifier,
              snapshot: pageSnapshot
            };
            if (_this41.action) options.action = _this41.action;
            session.visit(frame.src, options);
          }
        };
      }
    }
  }, {
    key: "changeHistory",
    value: function changeHistory() {
      if (this.action) {
        var method = getHistoryMethodForAction(this.action);
        session.history.update(method, expandURL(this.element.src || ""), this.restorationIdentifier);
      }
    }
  }, {
    key: "handleUnvisitableFrameResponse",
    value: function () {
      var _handleUnvisitableFrameResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36(fetchResponse) {
        return _regenerator().w(function (_context36) {
          while (1) switch (_context36.n) {
            case 0:
              console.warn("The response (".concat(fetchResponse.statusCode, ") from <turbo-frame id=\"").concat(this.element.id, "\"> is performing a full page visit due to turbo-visit-control."));
              _context36.n = 1;
              return this.visitResponse(fetchResponse.response);
            case 1:
              return _context36.a(2);
          }
        }, _callee36, this);
      }));
      function handleUnvisitableFrameResponse(_x28) {
        return _handleUnvisitableFrameResponse.apply(this, arguments);
      }
      return handleUnvisitableFrameResponse;
    }()
  }, {
    key: "willHandleFrameMissingFromResponse",
    value: function willHandleFrameMissingFromResponse(fetchResponse) {
      var _this42 = this;
      this.element.setAttribute("complete", "");
      var response = fetchResponse.response;
      var visit = /*#__PURE__*/function () {
        var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37(url) {
          var options,
            _args8 = arguments;
          return _regenerator().w(function (_context37) {
            while (1) switch (_context37.n) {
              case 0:
                options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                if (url instanceof Response) {
                  _this42.visitResponse(url);
                } else {
                  session.visit(url, options);
                }
              case 1:
                return _context37.a(2);
            }
          }, _callee37);
        }));
        return function visit(_x29) {
          return _ref24.apply(this, arguments);
        };
      }();
      var event = dispatch("turbo:frame-missing", {
        target: this.element,
        detail: {
          response: response,
          visit: visit
        },
        cancelable: true
      });
      return !event.defaultPrevented;
    }
  }, {
    key: "handleFrameMissingFromResponse",
    value: function handleFrameMissingFromResponse(fetchResponse) {
      this.view.missing();
      this.throwFrameMissingError(fetchResponse);
    }
  }, {
    key: "throwFrameMissingError",
    value: function throwFrameMissingError(fetchResponse) {
      var message = "The response (".concat(fetchResponse.statusCode, ") did not contain the expected <turbo-frame id=\"").concat(this.element.id, "\"> and will be ignored. To perform a full page visit instead, set turbo-visit-control to reload.");
      throw new TurboFrameMissingError(message);
    }
  }, {
    key: "visitResponse",
    value: function () {
      var _visitResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38(response) {
        var wrapped, responseHTML, location, redirected, statusCode;
        return _regenerator().w(function (_context38) {
          while (1) switch (_context38.n) {
            case 0:
              wrapped = new FetchResponse(response);
              _context38.n = 1;
              return wrapped.responseHTML;
            case 1:
              responseHTML = _context38.v;
              location = wrapped.location, redirected = wrapped.redirected, statusCode = wrapped.statusCode;
              return _context38.a(2, session.visit(location, {
                response: {
                  redirected: redirected,
                  statusCode: statusCode,
                  responseHTML: responseHTML
                }
              }));
          }
        }, _callee38);
      }));
      function visitResponse(_x30) {
        return _visitResponse.apply(this, arguments);
      }
      return visitResponse;
    }()
  }, {
    key: "findFrameElement",
    value: function findFrameElement(element, submitter) {
      var _a;
      var id = getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
      return (_a = getFrameElementById(id)) !== null && _a !== void 0 ? _a : this.element;
    }
  }, {
    key: "extractForeignFrameElement",
    value: function () {
      var _extractForeignFrameElement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee39(container) {
        var element, id, _t3;
        return _regenerator().w(function (_context39) {
          while (1) switch (_context39.p = _context39.n) {
            case 0:
              id = CSS.escape(this.id);
              _context39.p = 1;
              element = activateElement(container.querySelector("turbo-frame#".concat(id)), this.sourceURL);
              if (!element) {
                _context39.n = 2;
                break;
              }
              return _context39.a(2, element);
            case 2:
              element = activateElement(container.querySelector("turbo-frame[src][recurse~=".concat(id, "]")), this.sourceURL);
              if (!element) {
                _context39.n = 5;
                break;
              }
              _context39.n = 3;
              return element.loaded;
            case 3:
              _context39.n = 4;
              return this.extractForeignFrameElement(element);
            case 4:
              return _context39.a(2, _context39.v);
            case 5:
              _context39.n = 7;
              break;
            case 6:
              _context39.p = 6;
              _t3 = _context39.v;
              console.error(_t3);
              return _context39.a(2, new FrameElement());
            case 7:
              return _context39.a(2, null);
          }
        }, _callee39, this, [[1, 6]]);
      }));
      function extractForeignFrameElement(_x31) {
        return _extractForeignFrameElement.apply(this, arguments);
      }
      return extractForeignFrameElement;
    }()
  }, {
    key: "formActionIsVisitable",
    value: function formActionIsVisitable(form, submitter) {
      var action = getAction(form, submitter);
      return locationIsVisitable(expandURL(action), this.rootLocation);
    }
  }, {
    key: "shouldInterceptNavigation",
    value: function shouldInterceptNavigation(element, submitter) {
      var id = getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
      if (element instanceof HTMLFormElement && !this.formActionIsVisitable(element, submitter)) {
        return false;
      }
      if (!this.enabled || id == "_top") {
        return false;
      }
      if (id) {
        var frameElement = getFrameElementById(id);
        if (frameElement) {
          return !frameElement.disabled;
        }
      }
      if (!session.elementIsNavigatable(element)) {
        return false;
      }
      if (submitter && !session.elementIsNavigatable(submitter)) {
        return false;
      }
      return true;
    }
  }, {
    key: "id",
    get: function get() {
      return this.element.id;
    }
  }, {
    key: "enabled",
    get: function get() {
      return !this.element.disabled;
    }
  }, {
    key: "sourceURL",
    get: function get() {
      if (this.element.src) {
        return this.element.src;
      }
    },
    set: function set(sourceURL) {
      var _this43 = this;
      this.ignoringChangesToAttribute("src", function () {
        _this43.element.src = sourceURL !== null && sourceURL !== void 0 ? sourceURL : null;
      });
    }
  }, {
    key: "loadingStyle",
    get: function get() {
      return this.element.loading;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.formSubmission !== undefined || this.resolveVisitPromise() !== undefined;
    }
  }, {
    key: "complete",
    get: function get() {
      return this.element.hasAttribute("complete");
    },
    set: function set(value) {
      var _this44 = this;
      this.ignoringChangesToAttribute("complete", function () {
        if (value) {
          _this44.element.setAttribute("complete", "");
        } else {
          _this44.element.removeAttribute("complete");
        }
      });
    }
  }, {
    key: "isActive",
    get: function get() {
      return this.element.isActive && this.connected;
    }
  }, {
    key: "rootLocation",
    get: function get() {
      var _a;
      var meta = this.element.ownerDocument.querySelector("meta[name=\"turbo-root\"]");
      var root = (_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/";
      return expandURL(root);
    }
  }, {
    key: "isIgnoringChangesTo",
    value: function isIgnoringChangesTo(attributeName) {
      return this.ignoredAttributes.has(attributeName);
    }
  }, {
    key: "ignoringChangesToAttribute",
    value: function ignoringChangesToAttribute(attributeName, callback) {
      this.ignoredAttributes.add(attributeName);
      callback();
      this.ignoredAttributes["delete"](attributeName);
    }
  }, {
    key: "withCurrentNavigationElement",
    value: function withCurrentNavigationElement(element, callback) {
      this.currentNavigationElement = element;
      callback();
      delete this.currentNavigationElement;
    }
  }]);
}();
function getFrameElementById(id) {
  if (id != null) {
    var element = document.getElementById(id);
    if (element instanceof FrameElement) {
      return element;
    }
  }
}
function activateElement(element, currentURL) {
  if (element) {
    var src = element.getAttribute("src");
    if (src != null && currentURL != null && urlsAreEqual(src, currentURL)) {
      throw new Error("Matching <turbo-frame id=\"".concat(element.id, "\"> element has a source URL which references itself"));
    }
    if (element.ownerDocument !== document) {
      element = document.importNode(element, true);
    }
    if (element instanceof FrameElement) {
      element.connectedCallback();
      element.disconnectedCallback();
      return element;
    }
  }
}
var StreamElement = /*#__PURE__*/function (_HTMLElement2) {
  function StreamElement() {
    _classCallCheck(this, StreamElement);
    return _callSuper(this, StreamElement, arguments);
  }
  _inherits(StreamElement, _HTMLElement2);
  return _createClass(StreamElement, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee40() {
        var _t4;
        return _regenerator().w(function (_context40) {
          while (1) switch (_context40.p = _context40.n) {
            case 0:
              _context40.p = 0;
              _context40.n = 1;
              return this.render();
            case 1:
              _context40.n = 3;
              break;
            case 2:
              _context40.p = 2;
              _t4 = _context40.v;
              console.error(_t4);
            case 3:
              _context40.p = 3;
              this.disconnect();
              return _context40.f(3);
            case 4:
              return _context40.a(2);
          }
        }, _callee40, this, [[0, 2, 3, 4]]);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "render",
    value: function () {
      var _render6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee42() {
        var _this45 = this;
        var _a;
        return _regenerator().w(function (_context42) {
          while (1) switch (_context42.n) {
            case 0:
              return _context42.a(2, (_a = this.renderPromise) !== null && _a !== void 0 ? _a : this.renderPromise = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee41() {
                var event;
                return _regenerator().w(function (_context41) {
                  while (1) switch (_context41.n) {
                    case 0:
                      event = _this45.beforeRenderEvent;
                      if (!_this45.dispatchEvent(event)) {
                        _context41.n = 2;
                        break;
                      }
                      _context41.n = 1;
                      return nextAnimationFrame();
                    case 1:
                      _context41.n = 2;
                      return event.detail.render(_this45);
                    case 2:
                      return _context41.a(2);
                  }
                }, _callee41);
              }))());
          }
        }, _callee42, this);
      }));
      function render() {
        return _render6.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "disconnect",
    value: function disconnect() {
      try {
        this.remove();
      } catch (_a) {}
    }
  }, {
    key: "removeDuplicateTargetChildren",
    value: function removeDuplicateTargetChildren() {
      this.duplicateChildren.forEach(function (c) {
        return c.remove();
      });
    }
  }, {
    key: "duplicateChildren",
    get: function get() {
      var _a;
      var existingChildren = this.targetElements.flatMap(function (e) {
        return _toConsumableArray(e.children);
      }).filter(function (c) {
        return !!c.id;
      });
      var newChildrenIds = _toConsumableArray(((_a = this.templateContent) === null || _a === void 0 ? void 0 : _a.children) || []).filter(function (c) {
        return !!c.id;
      }).map(function (c) {
        return c.id;
      });
      return existingChildren.filter(function (c) {
        return newChildrenIds.includes(c.id);
      });
    }
  }, {
    key: "performAction",
    get: function get() {
      if (this.action) {
        var actionFunction = StreamActions[this.action];
        if (actionFunction) {
          return actionFunction;
        }
        this.raise("unknown action");
      }
      this.raise("action attribute is missing");
    }
  }, {
    key: "targetElements",
    get: function get() {
      if (this.target) {
        return this.targetElementsById;
      } else if (this.targets) {
        return this.targetElementsByQuery;
      } else {
        this.raise("target or targets attribute is missing");
      }
    }
  }, {
    key: "templateContent",
    get: function get() {
      return this.templateElement.content.cloneNode(true);
    }
  }, {
    key: "templateElement",
    get: function get() {
      if (this.firstElementChild === null) {
        var template = this.ownerDocument.createElement("template");
        this.appendChild(template);
        return template;
      } else if (this.firstElementChild instanceof HTMLTemplateElement) {
        return this.firstElementChild;
      }
      this.raise("first child element must be a <template> element");
    }
  }, {
    key: "action",
    get: function get() {
      return this.getAttribute("action");
    }
  }, {
    key: "target",
    get: function get() {
      return this.getAttribute("target");
    }
  }, {
    key: "targets",
    get: function get() {
      return this.getAttribute("targets");
    }
  }, {
    key: "raise",
    value: function raise(message) {
      throw new Error("".concat(this.description, ": ").concat(message));
    }
  }, {
    key: "description",
    get: function get() {
      var _a, _b;
      return (_b = ((_a = this.outerHTML.match(/<[^>]+>/)) !== null && _a !== void 0 ? _a : [])[0]) !== null && _b !== void 0 ? _b : "<turbo-stream>";
    }
  }, {
    key: "beforeRenderEvent",
    get: function get() {
      return new CustomEvent("turbo:before-stream-render", {
        bubbles: true,
        cancelable: true,
        detail: {
          newStream: this,
          render: StreamElement.renderElement
        }
      });
    }
  }, {
    key: "targetElementsById",
    get: function get() {
      var _a;
      var element = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.getElementById(this.target);
      if (element !== null) {
        return [element];
      } else {
        return [];
      }
    }
  }, {
    key: "targetElementsByQuery",
    get: function get() {
      var _a;
      var elements = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.querySelectorAll(this.targets);
      if (elements.length !== 0) {
        return Array.prototype.slice.call(elements);
      } else {
        return [];
      }
    }
  }], [{
    key: "renderElement",
    value: function () {
      var _renderElement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee43(newElement) {
        return _regenerator().w(function (_context43) {
          while (1) switch (_context43.n) {
            case 0:
              _context43.n = 1;
              return newElement.performAction();
            case 1:
              return _context43.a(2);
          }
        }, _callee43);
      }));
      function renderElement(_x32) {
        return _renderElement.apply(this, arguments);
      }
      return renderElement;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
var StreamSourceElement = /*#__PURE__*/function (_HTMLElement3) {
  function StreamSourceElement() {
    var _this46;
    _classCallCheck(this, StreamSourceElement);
    _this46 = _callSuper(this, StreamSourceElement, arguments);
    _this46.streamSource = null;
    return _this46;
  }
  _inherits(StreamSourceElement, _HTMLElement3);
  return _createClass(StreamSourceElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.streamSource = this.src.match(/^ws{1,2}:/) ? new WebSocket(this.src) : new EventSource(this.src);
      connectStreamSource(this.streamSource);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.streamSource) {
        disconnectStreamSource(this.streamSource);
      }
    }
  }, {
    key: "src",
    get: function get() {
      return this.getAttribute("src") || "";
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
FrameElement.delegateConstructor = FrameController;
if (customElements.get("turbo-frame") === undefined) {
  customElements.define("turbo-frame", FrameElement);
}
if (customElements.get("turbo-stream") === undefined) {
  customElements.define("turbo-stream", StreamElement);
}
if (customElements.get("turbo-stream-source") === undefined) {
  customElements.define("turbo-stream-source", StreamSourceElement);
}
(function () {
  var element = document.currentScript;
  if (!element) return;
  if (element.hasAttribute("data-turbo-suppress-warning")) return;
  element = element.parentElement;
  while (element) {
    if (element == document.body) {
      return console.warn(unindent(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        You are loading Turbo from a <script> element inside the <body> element. This is probably not what you meant to do!\n\n        Load your application\u2019s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.\n\n        For more information, see: https://turbo.hotwired.dev/handbook/building#working-with-script-elements\n\n        \u2014\u2014\n        Suppress this warning by adding a \"data-turbo-suppress-warning\" attribute to: %s\n      "]))), element.outerHTML);
    }
    element = element.parentElement;
  }
})();
window.Turbo = Turbo;
start();
export { FrameElement, FrameLoadingStyle, FrameRenderer, PageRenderer, PageSnapshot, StreamActions, StreamElement, StreamSourceElement, cache, clearCache, connectStreamSource, disconnectStreamSource, navigator$1 as navigator, registerAdapter, renderStreamMessage, session, setConfirmMethod, setFormMode, setProgressBarDelay, start, visit };